import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';

import { initReactI18next } from 'react-i18next';

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          height: 'Height',
          metric_india: 'Metric (India)',
          metric_israel: 'Metric (Israel)',
          metric_australia: 'Metric (Australia)',
          metric: 'Metric',
          imperial: 'Imperial',
          unit_system: 'Unit system',
          recommendations_unit: 'Recommendations unit',
          soil_water_deficit: 'Soil Water Deficit',
          login_registration_confirmation_message:
            'Please confirm your registration by clicking the confirmation link you received in your email account.',
          login_registration_after_confirmation_message:
            'After confirmation, go to',
          login_registration_after_confirmation_message_2: 'and login.',
          login_enter_your_email: 'Enter your email',
          login_enter_your_password: 'Enter your password',
          login_enter_a_valid_email: 'Enter a valid email account',
          login_enter_a_valid_confirmation_code:
            'Enter a valid confirmation code',
          login_forgot_password: 'Forgot Password?',
          login_enter_verification_code_message:
            'Enter the verification code you received in your email account.',
          login_enter_confirmation_code_message:
            'Enter the confirmation code you received in your email account.',
          login_enter_confirmation_code: 'Enter the confirmation code',
          confirmation_code: 'Confirmation Code',
          login_new_password: 'New Password',
          login_enter_a_valid_password: 'Enter a valid password',
          login_dont_have_account_message: "Don't have an account?",
          login_sign_up: 'Sign Up',
          login_enter_first_name: 'Enter your first name',
          login_enter_last_name: 'Enter your last name',
          login_enter_phone_number: 'Enter your phone number',
          login_password_limitation_message:
            'Password must have at least 8 characters with at least one lower and upper case letters.',

          account_first_name_invalid_data_message: 'Enter a valid first name',
          account_last_name_invalid_data_message: 'Enter a valid last name',
          account_phone_number_invalid_data_message:
            'Enter a valid phone number',
          account_email_invalid_data_message: 'Enter a valid email',
          account_notifications: 'Receive Notifications?',
          loading: 'Loading...',
          kc_developments: 'Development',
          kc_auto_generate: 'Auto Generate',

          kc_crop_type_invalid_data_message: 'Enter a valid crop type',
          kc_variety: 'Variety',
          kc_variety_invalid_data_message: 'Enter a valid variety',
          kc_feature: 'Feature',
          kc_feature_invalid_data_message: 'Enter a valid feature',
          kc_sow_date: 'Sow date',
          edit_field_pre_season_irrigation_start_date:
            'Pre-season irrigation start date',
          kc_sow_date_invalid_data_message: 'Enter a valid sow date',
          kc_harvest_date: 'Harvest Date',
          kc_harvest_date_invalid_data_message: 'Enter a valid harvest date',
          kc_kc_table: 'KC Table',
          kc_by_month: 'Month',
          kc_by_growth_phase: 'Growth phase',
          kc_add_development_phase: 'Add a development phase',
          kc_phase_title_placeholder: 'Enter phase name...',
          kc_first_phase_starts: 'First phase starts on',
          edit_field_choose_area_message:
            'You must choose an area for your field',
          edit_field_finish_open_edit_message:
            'Finish or cancel the open edit before updating the field',
          edit_field_field_name: 'Field Name',
          edit_field_last_recommendation: 'Last Recommendation',
          edit_field_no_fields: 'No fields to display 😟',
          edit_field_field_name_invalid_data_message:
            'Enter a valid field name',
          edit_field_area_invalid_data_message:
            'Mark your field area using the draw menu on the left',
          edit_field_field_size_invalid_data_message:
            'Enter a valid field size',
          edit: 'Edit',
          edit_field_time_zone_invalid_message: 'Enter a valid time-zone',
          edit_field_water_meter_sensors: 'Flow Meter Sensors',
          edit_field_installation_date: 'Installation Date',
          edit_field_installation_date_invalid_message:
            'Enter a valid installation date',
          edit_field_contract_duration: 'Contract End Date',
          edit_field_contract_duration_invalid_message:
            'Contract duration must be bigger than today',
          edit_field_delete_field_message:
            'Are you sure you want to delete the field?',
          cluster: 'Cluster',
          meteorological_data: 'Meteorological Data',
          station: 'Station',
          distance: 'Distance',
          no_custom_station_added: 'No custom station added',
          select_station: 'Select station',
          select_station_type: 'Select station type',
          no_stations_found: 'No stations found',
          find_nearest_station: 'Find nearest station',
          add_station: 'Add',
          drag_to_reorder_station: 'Drag to reorder',
          station_priority_hint:
            "Drag to set priority. Data comes from the top station; any parameter it doesn't report is taken from the next one.",
          nearest_station_found:
            'Nearest active station: {{station}} ({{km}} km from the field)',
          no_station_nearby:
            'No active station with a known location within {{km}} km',
          remove_station: 'Remove station',
          none_default: 'None - Default',
          irrigate_command: 'Please irrigate',
          get_ready_to_irrigate: 'Get ready to irrigate',
          dont_irrigate_command: 'No need to irrigate',
          stress_level_very_high: 'Stress level is very high',
          stress_level_high: 'Stress level is high',
          stress_level_getting_low: 'Stress level is getting low',
          stress_level_optimal: 'Stress level is optimal',
          stress_level_no_stress: 'No Stress',
          no_recommendation_available: 'No Recommendation Available',
          no_recommendation: 'No Recommendation',
          expiration_date: 'Expiration date',
          soil_type: 'Soil type',
          crop_type: 'Crop type',
          next_actions: 'Next Actions',
          take_the_app_to_the_field:
            'Take N-Drip Connect with you to the field',
          new: '🎉 NEW!',
          history_graph: 'History Graph',
          download_the_app: 'Download the mobile app',
          coming_soon: 'Coming Soon',
          dashboard_irrigation_amount: 'Irrigation Amount',
          dashboard_my_fields: 'My Fields',
          dashboard_delete_field: 'Delete',
          dashboard_copy_field_id: 'Copy ID',
          dashboard_copy_field_description: 'Copy field description',
          dashboard_copied: 'Copied',
          dashboard_edit_field: 'Edit',
          dashboard_add_field: 'Add Field',
          dashboard_new_field: 'New Field',
          dashboard_loading_data_message:
            'We are gathering data, this should take between 6 to 8 hours',
          no_planner_events: 'All clear,\nno future actions at this time',
          management_distribution_units_management:
            'Distribution Units Management',
          transmitter_admin_page: 'Transmitter Test',
          search_transmitter_title: 'Search for a Transmitter',
          search_transmitter_description:
            'Enter a transmitter ID or select a field to view transmitter status and metrics.',
          transmitter_not_found: 'Transmitter not found or an error occurred.',
          error_occurred: 'An error occurred',
          retry: 'Try Again',
          detailed_data_unavailable:
            'Some detailed metrics could not be loaded.',
          latest: 'Latest',
          management_admins_only: 'admins only',
          management_farming_units_management: 'Farming Units Management',
          management_delete_distribution_message:
            'Are you sure you want to delete the distribution?',
          management_manage_distribution_users_title:
            'Manage {{distribution}} Users',
          management_enter_a_valid_username:
            'Enter a valid user name - ex. user@domain.com',
          management_enter_a_valid_distribution_name:
            'Enter a valid distribution name',
          management_enter_a_valid_farming_unit_name:
            'Enter a valid farming unit name',
          management_enter_a_valid_region: 'Enter a valid region',
          management_farming_unit_name: 'Farming unit name',
          management_farming_unit_salesforce_id: 'Salesforce ID',
          management_distribution_name: 'Distribution Name',
          login_page: 'Login Page',
          time_zone: 'Time Zone',
          tensiometers: 'Tensiometers',
          support_planner: 'Support Planner',
          Edit_field_planner_dynamic_update_title: 'Allow dynamic updates',
          Edit_field_planner_dynamic_update_description:
            'Recommendations will be affected by irrigation changes at any time',
          distribution_unit: 'Distribution Unit',
          farming_unit: 'Farming Unit',
          field_amount: 'Fields Amount',
          region: 'Region',
          actions: 'Actions',
          close: 'Close',
          done_button: 'Done',
          user: 'User',
          role: 'Role',
          admin: 'Admin',
          viewer: 'Viewer',
          moderator: 'Moderator',
          account: 'Account',
          preferences: 'Preferences',
          logout: 'Log out',
          first_name: 'First Name',
          last_name: 'Last Name',
          phone_number: 'Phone Number',
          email: 'Email',
          units: 'Units',
          area: 'Area',
          gdd: 'GDD',
          leaf_length: 'Leaf Length',
          et0: 'ETo',
          leached: 'Leached',
          plant: 'Plant',
          soil: 'Soil',
          temperature: 'Temperature',
          weight: 'Weight',
          pressure: 'Pressure',
          length: 'Length',
          volume: 'Volume',
          estimated_nitrogen_values: 'Estimated nitrogen values',

          temperature_celsius: 'Celsius',
          temperature_fahrenheit: 'Fahrenheit',
          weight_kg: 'Kg',
          weight_lb: 'lb',
          weight_tonne: 'Tonne',
          weight_short_ton: 'Short Ton',
          pressure_kpa: 'kPa',
          pressure_psi: 'PSI',
          pressure_cbar: 'CBar',
          pressure_mm: 'mm',
          pressure_pa: 'Pa',
          length_mm: 'mm',
          length_inch: 'Inch',
          volume_cubic_metre: 'Cubic Meter',
          volume_gallon: 'Gallon',
          volume_bushel: 'Bushel',
          volume_acre_foot: 'Acre Foot',
          volume_acre_inch: 'Acre Inch',
          volume_megaliter: 'Megaliter',

          phase: 'Phase',
          kc: 'Kc',
          kc_optimized: 'Kc optimized',
          duration: 'Duration',
          days: 'Days',

          months_january: 'January',
          months_february: 'February',
          months_march: 'March',
          months_april: 'April',
          months_may: 'May',
          months_june: 'June',
          months_july: 'July',
          months_august: 'August',
          months_september: 'September',
          months_october: 'October',
          months_november: 'November',
          months_december: 'December',
          show_archived: 'Show archived',
          choose_date: 'Choose Date',
          last_day: 'Last day',
          last_week: 'Last week',
          last_two_weeks: 'Last 2 weeks',
          last_month: 'Last month',
          last_six_months: 'Last 6 months',
          last_year: 'Last year',
          max: 'Max',
          min: 'Min',
          pressure_boundaries: 'Pressure Boundaries',
          max_date_range: 'Max',
          activity_dates: 'Activity dates',

          supporting_data: 'Supporting Data',
          water_stress_level: 'Water Stress Level',
          fertilization_gauge_title: 'Nitrogen Levels',
          map_view: 'Map View',

          serial_no: 'Serial no.',
          sensor_serial_no: "Sensor's Serial no.",
          sensor_latitude: "Sensor's Latitude",
          sensor_longitude: "Sensor's Longitude",
          water_meter_units: 'M³ per pulse',
          name: 'Name',
          latitude: 'Latitude',
          longitude: 'Longitude',

          create: 'Create',
          update: 'Update',
          field: 'Field',
          cancel: 'Cancel',
          delete: 'Delete',
          ok: 'OK',
          confirmation: 'Confirmation',
          confirm: 'Confirm',
          yes: 'Yes',
          no: 'No',
          home: 'Home',
          change: 'Change',
          forgot: 'Forgot',
          password: 'Password',
          login: 'Login',
          prefix: 'Prefix',
          register: 'Register',
          settings: 'Settings',
          support: 'Support',
          support_leave_message: 'Leave us a message',
          support_name_label: 'Your name',
          support_email_label: 'Email address',
          support_optional: 'optional',
          support_required: 'required',
          support_name_placeholder: 'Enter your name',
          support_help_message_title: 'How can we help you?',
          support_attachments: 'Attachments',
          support_add_files: 'Add up to {{count}} files',
          support_drop_files: 'Drop files here',
          support_remove_attachment: 'Remove attachment',
          support_minimize_widget: 'Minimize widget',
          support_message_sent: 'Message sent successfully',
          support_message_failed: 'Something went wrong',
          support_sending: 'Sending...',
          support_login_required:
            'You must be logged in to send a support message.',
          send: 'Send',
          back: 'Back',
          based_on: 'Based on',
          amount: 'Amount',
          date_and_time: 'Date & Time',
          report: 'Report',
          hour: 'hour',
          hours: 'hours',
          minute: 'minute',
          minutes: 'minutes',
          report_irrigation: 'Report Irrigation',
          report_nitrogen: 'Report Nitrogen',
          irrigation_reported_successfully: 'Irrigation Reported Successfully',
          fertilization_reported_successfully:
            'Fertilization Reported Successfully',
          rain_reported_successfully: 'Rain Reported Successfully',
          wtr_reported_successfully: 'Water Treatment Reported Successfully',
          is_manure: 'Is Manure?',
          irrigation: 'Irrigation',
          select_sensors: 'Select Sensors',
          select_all: 'Select All',
          manure: 'Manure',
          nitrogen: 'Nitrogen',
          fertilization_history: 'Fertilization History',
          water_pressure_history: 'Water Pressure History',
          designed_pressure: 'Designed pressure',
          support_ndvi: 'Support NDVI?',
          n_in_organic_matter: 'N in Organic Matter',
          initial_concentrations: 'Initial Concentrations',
          should_automate_irrigation: 'Automate Irrigation',
          location: 'Location',
          i_agree_to: 'I agree to ',
          terms_and_conditions: 'terms and conditions',
          language: 'Language',
          last_update: 'Last update: ',
          hours_ago: '{0}h ago',
          hour_ago: '{0}h ago',
          day_ago: '{0}d ago',
          days_ago: '{0}d ago',
          days_ago_suffix: 'days ago',
          week_ago: '{0} week ago',
          weeks_ago: '{0} weeks ago',
          minute_ago: '{0}min ago',
          minutes_ago: '{0}min ago',
          ago: 'ago',
          today: 'today',
          yesterday: 'yesterday',
          enter_transmitter_id: 'Enter the transmitter ID',
          transmitter_id: 'Transmitter ID',
          transmitter_data_missing: 'Transmitter data missing',
          sim_activation:
            'Sim is being activated, please wait 10 minutes before testing again',
          last_seen: 'Last Seen',
          recent_analog_values: 'Recent Analog Values',
          recent_connectivity_values: 'Recent Connectivity Values',
          recent_battery_values: 'Recent Battery Values',
          recent_c1_values: 'Recent C1 Values',
          recent_errors_values: 'Recent Error Values',
          installation_date: 'Installation Date',
          modem_version: 'Modem Version',
          modem_hardware: 'Modem Hardware',
          iccid: 'ICCID',
          sensor_batch: 'Sensor Batch',
          transmission_interval: 'Transmission Interval',
          sample_interval: 'Sample Interval',
          micro_version: 'Micro Version',
          sim_last_event: 'SIM last event',
          date: 'Date',
          value: 'Value',
          test: 'Test',
          Sand: 'Sand',
          'Loamy Sand': 'Loamy Sand',
          'Sandy Loam': 'Sandy Loam',
          Loam: 'Loam',
          Silt: 'Silt',
          'Silty Loam': 'Silty Loam',
          'Sandy Clay Loam': 'Sandy Clay Loam',
          'Clay Loam': 'Clay Loam',
          'Silty Clay Loam': 'Silty Clay Loam',
          'Sandy Clay': 'Sandy Clay',
          'Silty Clay': 'Silty Clay',
          Clay: 'Clay',
          'Mix of Peat types': 'Mix of Peat types',
          'Coconut fiber': 'Coconut fiber',
          'Mixed Tuff': 'Mixed Tuff',
          water_potential_graph: 'Water potential graph',
          Cabbage: 'Cabbage',
          Carrot: 'Carrot',
          Cauliflower: 'Cauliflower',
          Celery: 'Celery',
          Lettuce: 'Lettuce',
          Onion: 'Onion',
          Spinach: 'Spinach',
          Radish: 'Radish',
          Eggplant: 'Eggplant',
          'Sweet pepper': 'Sweet pepper',
          Tomato: 'Tomato',
          Cantaloupe: 'Cantaloupe',
          Cucumber: 'Cucumber',
          'Pumpkin (Winter Squash)': 'Pumpkin (Winter Squash)',
          Squash: 'Squash',
          Zucchini: 'Zucchini',
          'Sweet Melon': 'Sweet Melon',
          Beet: 'Beet',
          Cassava: 'Cassava',
          Potato: 'Potato',
          'Sweet potato': 'Sweet potato',
          'Sugar Beet': 'Sugar Beet',
          Bean: 'Bean',
          'Faba bean, broad bean': 'Faba bean, broad bean',
          'Green Gram': 'Green Gram',
          Cowpea: 'Cowpea',
          'Peanut (Groundnut)': 'Peanut (Groundnut)',
          Lentil: 'Lentil',
          Pea: 'Pea',
          Soybean: 'Soybean',
          Artichoke: 'Artichoke',
          Asparagus: 'Asparagus',
          Cotton: 'Cotton',
          Flax: 'Flax',
          'Castorbean (Ricinus)': 'Castorbean (Ricinus)',
          Safflower: 'Safflower',
          Sesame: 'Sesame',
          Sunflower: 'Sunflower',
          Barley: 'Barley',
          Oat: 'Oat',
          Wheat: 'Wheat',
          Maize: 'Maize',
          Millet: 'Millet',
          Sorghum: 'Sorghum',
          Rice: 'Rice',
          Alfalfa: 'Alfalfa',
          Bermuda: 'Bermuda',
          Sudan: 'Sudan',
          Sugarcane: 'Sugarcane',
          Banana: 'Banana',
          Pineapple: 'Pineapple',
          Grape: 'Grape',
          Hop: 'Hop',
          Citrus: 'Citrus',
          Olive: 'Olive',
          Pistachio: 'Pistachio',
          Walnut: 'Walnut',
          'Cattails, Bulrush': 'Cattails, Bulrush',
          Mango: 'Mango',
          Grapefruit: 'Grapefruit',
          Garden: 'Garden',
          Grass: 'Grass',
          'Genus Citrus': 'Genus Citrus',
          Avocado: 'Avocado',
          Coffee: 'Coffee',
          Corn: 'Corn',
          Lychee: 'Lychee',
          'Peach, Nectarine': 'Peach, Nectarine',
          Watermelon: 'Watermelon',
          'Date Palm': 'Date Palm',
          Pomegranate: 'Pomegranate',
          Cannabis: 'Cannabis',
          Pepper: 'Pepper',
          Blackberry: 'Blackberry',
          Strawberry: 'Strawberry',
          Pecan: 'Pecan',
          start: 'Start',
          end: 'End',
          discharge: 'Discharge',
          'recent wfr samples': 'Recent Flow Meter Values',
          day_sunday: 'Sunday',
          day_monday: 'Monday',
          day_tuesday: 'Tuesday',
          day_wednesday: 'Wednesday',
          day_thursday: 'Thursday',
          day_friday: 'Friday',
          day_saturday: 'Saturday',
          planning: 'Planning',
          field_view: 'Field View',
          farm_view: 'Farm View',
          new_section:
            'New!\nSee your entire farm and irrigation insights at a glance',
          weekly_performance: 'Weekly performance',
          weekly_performance_tooltip:
            'Displays actual irrigation events compared to the recommended schedule.',
          irrigation_activity_tooltip:
            'Shows when the last irrigation ended, or indicates an active irrigation',
          root_zone_water_potential_tooltip:
            'Shows root-zone water potential measurements from the field’s representative sensor over the most recent seven available days.',
          crop_water_availability: 'Crop Water\nAvailability',
          water_availability_high: 'High',
          water_availability_medium: 'Medium',
          water_availability_low: 'Low',
          water_availability_no_data: 'No Data',
          ndvi_layer: 'NDVI Layer',
          farm_map: 'Farm map',
          field_details: 'Field details',
          select_a_field_to_view_details:
            'Select a field to view its water potential graph',
          select_a_field_to_view_its_details:
            'Select a field to view its details',
          date_chip_1d: '1D',
          date_chip_1w: '1W',
          date_chip_2w: '2W',
          date_chip_1m: '1M',
          date_chip_6m: '6M',
          date_chip_1y: '1Y',
          graphs: 'Graphs',
          map: 'Map',
          previous: 'Previous',
          next: 'Next',
          field_name: 'Field Name',
          sort: 'Sort',
          advanced: 'Advanced',
          advanced_mode: 'Advanced Mode',
          unknown_field: 'Unknown Field',
          not_available: 'Not available',
          irrigating: 'Irrigating',
          no_data: 'No data',
          plan: 'Plan',
          since_date: 'Since {{date}}',
          flow_meter_source: 'Flow Meter',
          manual_input_source: 'Manual Input',
          connect_sensor_source: 'Connect Sensor',
          no_fields_available: 'No fields available',
          fields: 'Fields',
          recommendation: 'Recommendation',
          stress_level: 'Stress Level',
          root_zone_wp: 'Root-zone WP',
          map_satellite: 'Satellite',
          map_topography: 'Topography',
          map_streets: 'Streets',
          ndvi_timeline: 'NDVI timeline',
          planning_days: 'Days',
          planning_weeks: 'Weeks',
          planning_publish: 'Publish',
          planning_planned: 'planned',
          planning_used: 'used',
          tomorrow: 'tomorrow',
          later: 'later',
          event: 'Event',
          events: 'events',
          fertilization: 'Fertilization',
          hcl: 'HCl',
          hpo: 'HPO',
          note: 'Footnote',
          planning_note_placeholder: 'Write your massage here',
          'out of': 'out of',
          'accumulated this week': 'accumulated this week',
          'accumulated this season': 'accumulated this season',
          sensors: 'Sensors',
          valves: 'Valves',
          type: 'Type',
          'coming up': 'coming up',
          notify: 'notify',
          irrigation_system: 'Irrigation System',
          irrigation_type: 'Irrigation Type',
          irrigation_rate: 'Irrigation Rate',
          irrigation_time_frames: 'Irrigation Time Frames',
          define_time_frames: 'Define available time frames for irrigation',
          start_day: 'Start day',
          start_hour: 'Start hour',
          end_hour: 'End hour',
          time_frame_conflict:
            'Selected Time Frame conflicts with existing Time Frame',
          select_different_hour: 'Please select Different Hour',
          select_different_day: 'Please select Different Day',
          no_time_frames: 'There are no irrigation time frames constraints',
          for_this_field: 'for this field at the moment',
          locate_coordinates: 'Locate coordinates',
          ignore_sensor_during_calculations: 'Ignore during calculations',
          ignore_sensor_during_calculations_and_hide:
            'Ignore during calculations and hide',
          consider_as_flow_meter: 'Consider as flow meter',
          alerts: 'alerts',
          stop_data_collection: 'Stop data collection',
          accumulated_water_input: 'Accumulated water input',
          soil_temperature: 'Soil Temperature',
          soil_temperature_graph_title: 'Soil Temperature',
          precipitation: 'Precipitation',
          water_potential: 'Water potential',
          irrigation_activity: 'Irrigation activity',
          root_zone_water_potential: 'Root zone water potential',
          petiole: 'Petiole',
          minimum: 'Min',
          maximum: 'Max',
          max_bigger_than_min: 'Max value need to be bigger than the Min value',
          min_smaller_than_max:
            'Min value need to be smaller than the Max value',
          updated: 'Updated',
          last_synced: 'Last synced:',
          not_yet_set: 'Not yet set',
          missing_values: 'Values are missing',
          start_date: 'Start date',
          end_date: 'End date',
          fertigation_concentrations: 'Fertigation concentrations',
          no_fertigation_concentrations_message:
            'There are no fertigation concntrations',
          days_from_sowing: 'Days from Sowing',
          Field_details_days_in_season: 'Days in season',
          field_size: 'Field size',
          sensor_type: 'Sensor type',
          sensor_sub_type: 'Sensor Sub type',
          duplicate_field: 'Duplicate Field',
          duplicate: 'Duplicate',
          dashboard_move_to_archive: 'Archive',
          dashboard_unarchive: 'Unarchive',
          alphabetic: 'Alphabetic',
          sort_by: 'Sort by',
          sort_alphabetic: 'Alphabetic',
          sort_crop_availability: 'Crop water availability',
          sort_last_irrigation_new_old: 'Last irrigation (New → Old)',
          sort_last_irrigation_old_new: 'Last irrigation (Old → New)',
          sort_last_irrigation_duration_short_long:
            'Last irrigation (Shortest → Longest)',
          sort_last_irrigation_duration_long_short:
            'Last irrigation (Longest → Shortest)',
          sort_weekly_performance_high_low: 'Weekly performance (High → Low)',
          sort_weekly_performance_low_high: 'Weekly performance (Low → High)',
          Almond: 'Almond',
          Apple: 'Apple',
          Arugula: 'Arugula',
          Blueberry: 'Blueberry',
          Broccoli: 'Broccoli',
          'Faba Bean, Broad Bean': 'Faba Bean, Broad Bean',
          Fig: 'Fig',
          Garlic: 'Garlic',
          Guayule: 'Guayule',
          Jojoba: 'Jojoba',
          Kiwi: 'Kiwi',
          Loquat: 'Loquat',
          Mandarin: 'Mandarin',
          Moringa: 'Moringa',
          Nectarine: 'Nectarine',
          Orange: 'Orange',
          Peach: 'Peach',
          Peony: 'Peony',
          Raspberry: 'Raspberry',
          'Sweet Cherry': 'Sweet Cherry',
          'Sweet Pepper': 'Sweet Pepper',
          'Sweet Potato': 'Sweet Potato',
          '1st Cutting Cycle': '1st Cutting Cycle',
          'Other Cutting Cycles': 'Other Cutting Cycles',
          'Clay (Red Oxisol) (Pivot Irrigation)':
            'Clay (Red Oxisol) (Pivot Irrigation)',
          'Clay (Red Oxisol)': 'Clay (Red Oxisol)',
          'Coconut Fiber': 'Coconut Fiber',
          'Silt Loam': 'Silt Loam',
          'Clay (Ramot Gonen Pardes)': 'Clay (Ramot Gonen Pardes)',
          'Clay Loam (6mm)': 'Clay Loam (6mm)',
          'Sandy Clay (Shefayim)': 'Sandy Clay (Shefayim)',
          'Clay 1000mm': 'Clay 1000mm',
          'Clay Loam Et': 'Clay Loam Et',
          'Loam (Agroterra)': 'Loam (Agroterra)',
          'Clay (Ramot Gonen)': 'Clay (Ramot Gonen)',
          'Clay (Red Oxisol) Au': 'Clay (Red Oxisol) Au',
          'Clay Loam (Peanuts)': 'Clay Loam (Peanuts)',
          'Clay (Adashim)': 'Clay (Adashim)',
          'Clay Loam Au': 'Clay Loam Au',
          'Clay (Pivot Irrigation)': 'Clay (Pivot Irrigation)',
          'Clay Au': 'Clay Au',
          'Clay (Cotton)': 'Clay (Cotton)',
          'Loam (6mm)': 'Loam (6mm)',
          'Clay Loam (Daliot)': 'Clay Loam (Daliot)',
          'Sand Ornamental': 'Sand Ornamental',
          'Clay Loam (Pivot Irrigation)': 'Clay Loam (Pivot Irrigation)',
          'Mix Of Peat Types': 'Mix Of Peat Types',
          'Clay Loam (Ak-Chin)': 'Clay Loam (Ak-Chin)',
          Planner: 'Planner',
          'Planned irrigation': 'Planned irrigation',
          Irrigated: 'Irrigated',
          'Nitrogen graph': 'Nitrogen graph',
          search_by_field: 'Search By Field',
          free_search: 'Free Search',
          transmitters: 'Transmitters',
          distribution: 'Distribution',
          sensor: 'Sensor',
          global_search_placeholder:
            'Search distributions, farming units, fields and sensors',
          global_search_empty_hint: 'Start typing to search by name or ID',
          global_search_no_results: 'No results found',
          global_search_more_results:
            'Showing the first {{shown}} of {{total}} results',
          global_search_recent_fields: 'Recent fields',
          global_search_hint_navigate: 'Navigate',
          global_search_hint_select: 'Select',
          week: 'Week',
          season: 'Season',
          reported: 'Reported',
          events_list: 'Events List',
          no_reported: 'No Reported Events',
          transmitter_name: 'Transmitter Name',
          details: 'details',
          'discharge over time': 'Discharge over time',
          select_water_input: 'Select Water Input',
          etc: 'ETc',
          next_day: 'Next day',
          crop_management: 'Crop Management',
          add_new_crop: 'Add New Crop',
          edit_parameters: 'Edit Parameters',
          select_or_enter_crop_type: 'Select or enter crop type',
          select_or_enter_variety: 'Select or enter variety',
          enter_sub_variety: 'Enter sub variety (optional)',
          select_or_enter_feature: 'Select or enter feature',
          add_new_button: 'Add New',
          select_crop: 'Select crop...',
          phenological_phases: 'Phenological Phases',
          gdd_parameters: 'GDD Parameters',
          yield_parameters: 'Yield Parameters',
          fields_using_crop: 'Fields Using This Crop',
          permission_hint: 'Only showing fields you have permission to view',
          no_fields_found: 'No fields found using this crop configuration',
          select_crop_hint: 'Select a crop type to view and edit parameters',
          loading_crop_data: 'Loading crop data...',
          add_phase: 'Add Phase',
          duration_days: 'Duration (Days)',
          duration_gdd: 'Duration (GDD)',
          is_development: 'Is Development',
          stress_active: 'Stress Active',
          stress_factor: 'Stress Factor',
          inherited: 'Inherited',
          crop_updated_successfully: 'Crop updated successfully',
          crop_update_failed: 'Failed to update crop',
          crop_added_successfully: 'Crop added successfully',
          crop_add_failed: 'Failed to add crop',
          crop_key_already_exists: 'This crop key already exists',
          insights_tab: 'Insights',
          number_of_fields: 'Number of fields',
          total_area: 'Total area',
          total_water_usage: 'Total water usage',
          total_fertilizers_usage: 'Total fertilizers usage',
          total_nitrogen_leached: 'Total nitrogen leached',
          crop_types: 'Crop types',
          report_event: 'Report event',
          save: 'Save',
          measurement: 'measurement',
          rain: 'rain',
          starting_time: 'starting time',
          'please select': 'Please Select',
          create_planner_item: 'add new planner item',
          update_planner_item: 'update planner item',
          containing: 'containing',
          no_cluster: 'No Cluster',
          offset: 'Offset',
          notes: 'Notes',
          week_total: 'Week total',
          season_total: 'Season total',
          selected_field_only: 'Selected field only',
          farming_type: 'Farming type',
          plant_height: 'Plant Height',
          fert_tank_height: 'Fert tank level',
          Fert_tank_volume: 'Fert tank volume',
          fert_tank: 'Fert tank',
          calibration_data: 'Calibration data',
          recommendations_tooltip:
            'Recommendations are insights that help optimize yields and improve decision-making',
          allow_notifications: 'Allow Notifications',
          notifications_channels: 'In which channels you will be notified',
          event_type: 'Event Type',
          login_enter_your_email_forgot_password:
            'Enter your email and we will send you a code for resetting your password:',
          push: 'Push',
          recommendations: 'Recommendations',
          field_notifications:
            'Which notifications you will receive for each field',
          none: 'None',
          notifications: 'Notifications',
          notifications_phase:
            'Control notification types and channels by which you will be notified, per each field',
          alerts_tooltip:
            'Alerts flag adverse events that require immediate action, to protect your crops',
          all_fields: 'All fields',
          current_field: 'Current field',
          alerts_message_continuous_irrigation_notification_center_title:
            'Continuous irrigation alert - In fieldX',
          alerts_message_continuous_irrigation_notification_center_body:
            "We've detected continuous irrigation for over 2 days in the field. To protect your crops and resources, we strongly advise inspecting the field for over-irrigation.",
          low_pressure_event_hint: 'Low pressure detected in this irrigation',
          high_pressure_event_hint: 'High pressure detected in this irrigation',
          low_pressure_detected_value: 'Low pressure detected: {{value}}',
          high_pressure_detected_value: 'High pressure detected: {{value}}',
          alerts_message_low_pressure_notification_center_title:
            'Low pressure detected in fieldX',
          alerts_message_low_pressure_notification_center_body:
            'Pressure measured in fieldX dropped below the minimum defined for this sensor, which can reduce the water delivered and affect its distribution across the field. We advise checking the filters, valves and pipes.',
          alerts_message_high_pressure_notification_center_title:
            'High pressure detected in fieldX',
          alerts_message_high_pressure_notification_center_body:
            'Pressure measured in fieldX rose above the maximum defined for this sensor, which can strain the irrigation system and affect water distribution. We advise checking the pressure regulation and downstream valves.',
          alerts_message_sensor_extreme_dry_conditions_notification_center_title:
            'Extreme dry conditions detected in the field - Data received from sensorX',
          alerts_message_sensor_extreme_dry_conditions_notification_center_body:
            'Data from sensorX indicates that conditions in the field are extremely dry. To ensure accurate data and protect your crops, we recommend inspecting the irrigation plan, and the irrigation system around the sensor',
          alerts_message_long_dry_period_notification_center_title:
            'Long period without irrigation - Irrigation of fieldX advised',
          alerts_message_long_dry_period_notification_center_body:
            'fieldX has not received water for at least 10 days, contributing to the water stress level We advise irrigating the field to safeguard your crops, according to your N-Drip recommendations.',
          alerts_message_drying_trend_notification_center_title:
            'Drying trend detected in your field',
          alerts_message_wetting_trend_notification_center_title:
            'Wetting trend detected in your field',
          alerts_message_drying_trend_notification_center_body:
            'We’ve noticed a decreasing trend of the soil water potential in fieldX, below the recommended level. To optimize crop health, please review your current irrigation practice and adjust according to N-Drip recommendations.',
          alerts_message_wetting_trend_notification_center_body:
            'We’ve noticed an increasing trend of the soil water potential in fieldX, above the recommended level. To optimize crop health, please review your current irrigation practice and adjust according to N-Drip recommendations.',
          alerts_message_excessive_heat_notification_center_title:
            'High air-temperature',
          alerts_message_excessive_heat_notification_center_body:
            'High temperatures for your crop are forecast for the fieldX in the coming days.\nTo protect your crops, please review and implement our updated irrigation recommendations.',
          alerts_message_extreme_cold_notification_center_title:
            'Low air-temperature',
          alerts_message_extreme_cold_notification_center_body:
            'Low temperatures for your crop are forecast for the fieldX in the coming days.\nTo protect your crops, please review and implement our updated irrigation recommendations.\n',
          alerts_message_dryland_long_dry_period_notification_center_title:
            'Long dry period detected',
          alerts_message_dryland_long_dry_period_notification_center_body:
            'fieldX has not received water for at least 10 days, contributing to the water stress level.',
          alerts_message_dryland_sensor_exterme_dry_notification_center_title:
            'Extreme dry conditions detected in the field - Data received from sensorX',
          alerts_message_dryland_sensor_exterme_dry_notification_center_body:
            'Data from sensorX indicates that conditions in the field are extremely dry',
          alerts_message_dryland_drying_trend_notification_center_title:
            'Drying trend detected in your field',
          alerts_message_dryland_drying_trend_notification_center_body:
            'We’ve noticed a decreasing trend of the soil water potential in fieldX, contributing to the water stress level',
          alerts_message_low_tank_fert_notification_center_title:
            'Low fertilizer level detected in fieldX',
          alerts_message_low_tank_fert_notification_center_body:
            'We have detected that the fertilizer level in the tank at fieldX has reached the minimum threshold of 10% of the tank’s operational height. Please arrange to refill the tank to ensure continued fertilization of the crops.',
          alerts_message_dryland_wetting_trend_notification_center_title:
            'Wetting trend detected in your field',
          alerts_message_dryland_wetting_trend_notification_center_body:
            'We’ve noticed an increasing trend of the soil water potential in fieldX',
          alerts_message_dryland_excessive_heat_notification_center_title:
            'Heat wave alert',
          alerts_message_dryland_excessive_heat_notification_center_body:
            'A significant heat wave is forecast for the fieldX area in the coming days',
          alerts_message_dryland_extreme_cold_notification_center_title:
            'Cold wave alert',
          alerts_message_dryland_extreme_cold_notification_center_body:
            'A significant cold wave is forecast for the fieldX area in the coming days.',
          alerts_message_dryland_ndvi_notification_center_title:
            'Decreasing vegetative activity',
          alerts_message_dryland_ndvi_notification_center_body:
            'Our recent analysis of NDVI image history has revealed a notable decrease in vegetation growth within fieldX. To optimize crop health, please review your current irrigation practice.',
          no_notifications: 'There are no notifications at the moment',
          load_more: 'Load more',
          notifications_welcome_message_title:
            'Welcome to the new notifications panel',
          notifications_welcome_message_body:
            'Stay on top of current and expected important events in your fields trough desktop and mobile',
          planner_days_shorts_sun: 'Sun',
          planner_days_shorts_mon: 'Mon ',
          planner_days_shorts_tue: 'Tue',
          planner_days_shorts_wed: 'Wed',
          planner_days_shorts_thu: 'Thu',
          planner_days_shorts_fri: 'Fri',
          planner_days_shorts_sat: 'Sat',
          shorts_months_january: 'Jan',
          shorts_months_february: 'Feb',
          shorts_months_march: 'Mar',
          shorts_months_april: 'Apr',
          shorts_months_may: 'May',
          shorts_months_june: 'Jun',
          shorts_months_july: 'Jul',
          shorts_months_august: 'Aug',
          shorts_months_september: 'Sep',
          shorts_months_october: 'Oct',
          shorts_months_november: 'Nov',
          shorts_months_december: 'Dec',
          dont_show_again: 'Don’t show again',
          notifications_settings: 'Notifications settings',
          read_more: 'Read more',
          show_less: 'Show less',
          distribution_menu_select: 'Select Distribution',
          farming_unit_menu_select: 'Select Farming Unit',
          field_menu_select: 'Select Field',
          recent_field: 'Recent field',
          discharge_test: 'Discharge Test',
          planner_season_start: 'Season start',
          planner_season_end: 'Season end',
          planner_growth_phase_initial: 'Initial',
          planner_growth_phase_development: 'Development',
          planner_growth_phase_middle: 'Middle',
          planner_growth_phase_late: 'Late',
          planner_add_event_button: 'Add event',
          planner_water_treatment: 'Water treatment',
          planner_add_button: 'Add',
          planner_start_time: 'Start time',
          country: 'Country',
          monday_id: 'Monday ID',
          delete_item_title: 'The item will be deleted',
          delete_item_text:
            'This action can not be reverted and the data will be lost',
          average: 'Average',
          seconds: 'sec',
          event_delete_successfully: 'The event was deleted successfully',
          reported_successfully: 'The test has been reported successfully',
          report_unsuccessfully:
            'The event cannot be reported at this time. Please try again later',
          event_delete_unsuccessfully:
            'The event cannot be deleted at this moment, please try again later',
          Insights_title_county: 'County',
          Insights_group_by: 'Group by',
          edit_field_measured_irrigation_rate: 'Measured irrigation rate',
          edit_field_custom_irrigation_rate: 'Custom irrigation rate',
          edit_field_representative_input_checkbox:
            'Use measured irrigation rate once available. This will impact the Planner',
          edit_field_tank_type: 'Tank type',
          edit_field_recommendation_display: 'Show irrigation data in',
          recommendation_display_duration: 'Duration',
          recommendation_display_amount: 'Amount',
          edit_field_recommendation_display_description:
            'Duration is the default for N-Drip, Seepage, Flood and Furrow systems, Amount for the rest. Changing the irrigation type resets this to that system default.',
          timeframe_name: 'Timeframe name',
          wtr_checkbox: 'Include water treatment',
          kc_phases_stress_checkbox: 'Apply stress',
          kc_phases_stress_tooltip:
            'Start a planned period of crop water stress according to the following percentage reduction in ETc',
          edit_field_irrigation_timeframe_source_soil: 'Soil type limitation',
          edit_field_irrigation_timeframe_tooltip: 'Original limitation:',
          edit_field_irrigation_timeframe_source_irrigation_rate:
            'Irrigation rate',
          edit_field_irrigation_timeframe_source_user: 'Defined by user',
          source: 'Source',
          discharge_result_exceeding_hint:
            'Test result deviates from the discharge trend',
          Timeframe_no_end_date: 'Until further notice',
          Farming_unit_entity_basic_info: 'Basic info',
          WT_protocol_edit_field_water_properties_section_title:
            'Water properties',
          WT_protocol_edit_field_water_source: 'Water source',
          WT_protocol_edit_field_water_conveyance: 'Water conveyance ',
          WT_protocol_edit_field_water_analysis_section_title: 'Water analysis',
          WT_protocol_edit_field_water_analysis_section_subtitle:
            'See recommended ranges in each cell',
          WT_protocol_edit_field_water_analysis_table_materials: 'Materials',
          WT_protocol_edit_field_water_analysis_table_score: 'Score',
          WT_protocol_edit_field_water_analysis_table_low: 'Low',
          WT_protocol_edit_field_water_analysis_table_medium: 'Medium',
          WT_protocol_edit_field_water_analysis_table_high: 'High',
          WT_protocol_edit_field_water_analysis_table_organic: 'Organic',
          WT_protocol_edit_field_water_analysis_table_calc: 'Calc',
          WT_protocol_edit_field_water_analysis_table_fe: 'Fe',
          WT_protocol_edit_field_material_concentrations:
            'Material concentrations',
          WT_protocol_edit_field_acid_titration: 'Acid titration',
          WT_protocol_edit_field_HPO_concentrations: 'HPO concentrations',
          Farming_unit_entity_tooltip:
            'Disabled elements can be edited through the farming unit',
          WT_timing_recommendation_after_irrigation_starts:
            'After 30 min of irrigation',
          WT_timing_recommendation_last_hour: 'Last hour of irrigation',
          Fert_sensor_fertlization_type: 'Fertilizer type',
          fertilizer_meter_id: 'Fertilizer meter ID',
          add_fertilizer: 'Add fertilizer',
          Farming_unit_entity_all: 'All',
          basic_info: 'Basic Info',
          KC_phases_title: 'Growth phase',
          KC_phases_title_pre_season: 'Pre season',
          KC_phases_title_in_between_seasons: 'Between seasons',
          KC_phases_phase_tooltip_start: 'Start',
          KC_phases_phase_tooltip_end: 'End',
          KC_phases_button_save: 'Save',
          KC_phases_button_reset: 'Reset',
          KC_phases_stress_inidication: 'Controlled deficit irrigation',
          KC_phases_button_edit: 'Edit',
          KC_phases_fast_flow: 'Set current phase',
          KC_phases_now_indication: 'Now',
          KC_phases_estimated_short: 'Est.',
          KC_phases_season_ended: 'Season ended',
          KC_phases_season_end: 'Season ends in',
          KC_phases_estimated_season_end: 'Estimated season end',
          KC_phases_edit_mode_default_title:
            'Click on a phase to adjust its duration',
          installation_depth: 'Depth',
          tensiometer_range: 'Range',
          kc_phases_error_message: 'Value conflicts with another value',
          edit_field_timeframe_constraint_first_day: 'First day of the week',
          edit_field_planner_type_no_planner: 'No planner',
          edit_field_planner_type_by_day: 'Daily recommendation',
          edit_field_planner_type_by_week: 'Weekly recommendation',
          edit_field_planner_no_irrigation: 'No irrigation',
          edit_field_timeframe_constraint_season_target:
            'Season irrigation target',
          edit_field_timeframe_constraint_interval_mode:
            'Interval (Set the days interval between irrigations)',
          edit_field_timeframe_constraint_weekly_mode:
            'Weekly (Set the number of irrigations per week)',
          edit_field_timeframe_no_frequnecy_constraint:
            'If no timeframes are defined, planner will run every day',
          add_time_frames: 'Add timeframe constraints to see them here',
          new_planner_title: 'Irrigation recommendation',
          no_irrigation_planning_this_week: 'No irrigation needed at this time',
          new_planner_no_recommendation_available_indication:
            'No recommendation available - missing data',
          new_planner_feedback: 'Is this recommendation useful?',
          new_planner_rain_excluded:
            'Rain forecasts are excluded to ensure a reliable plan',
          new_planner_feedback_thanks: 'Thanks for sharing this info with us',
          gauge_low_v2: 'Low',
          gauge_good_v2: 'Good',
          gauge_critcal_v2: 'Critical',
          gauge_no_data_v2: 'No data',
          gauge_title_v2: 'Crop water status',
          gauge_title_v3: 'Crop water availability',
          gauge_high_v3: 'High',
          gauge_medium_v3: 'Medium',
          gauge_low_v3: 'Low',
          new_planner_recommendation_irrigate: 'Irrigate',
          new_planner_recommendation_amount: 'Amount',
          new_planner_recommendation_frequency: 'Frequency',
          new_planner_recommendation_times_a_week: 'times a week',
          new_planner_recommendation_every: 'every',
          new_planner_recommendation_days: 'days',
          new_planner_recommendation_format_every_day: 'every day',
          day: 'day',
          new_planner_recommendation_daily_return: 'Daily',
          new_planner_recommendation_daily_return_avg: 'avg.',
          new_planner_this_week: 'This week',
          new_planner_next_week: 'Next week',
          new_planner_previous_week: 'Previous week',
          new_planner_previuos_week: 'Previous week',
          edit_field_planner_changes_message_first_day_body:
            'By changing the first day of the week, recommendations will be affected',
          edit_field_planner_changes_message_mode_body:
            'By changing the irrigation modes, recommendations will be affected',
          select_graphs: 'Select graphs',
          accumulated_graph_baseline_recommendation_more_info_description:
            "ETc based on crop model (Kc × ETo), adjusted for your irrigation system's efficiency.",
          accumulated_graph_adaptive_recommendation_more_info_description:
            "ETc based on optimized Kc, adjusted for your irrigation system's efficiency.",
          accumulated_graph_title_baseline_recommendation:
            'Baseline recommendation',
          accumulated_graph_title_adaptive_recommendation:
            'Adaptive recommendation',
          field_list_title_: 'Fields list',
          soil_temperature_values: 'Soil temp daily avg, max, last h',
          assumption: 'Assumption',
          issue: 'Issue',
          extract_sensor: 'Extract Sensor',
          select_assumption: 'Select assumption',
          select_sensor: 'Select sensor',
          comment: 'Comment',
          reporting: 'Reporting...',
          air_burst: 'Air Burst',
          bad_values: 'Bad Values',
          no_transmission: 'No Transmission',
          low_pressure_detected: 'Low pressure detected',
          high_pressure_detected: 'High pressure detected',
          long_dry_period: 'Long dry period',
          drying_trend: 'Drying trend',
          wetting_trend: 'Wetting trend',
          sensor_not_responding_to_irrigation:
            'Sensor is not responding to irrigation',
          missed_irrigation: 'Missed irrigation',
          continuous_irrigation: 'Continuous irrigation',
          select_placeholder: 'Select...',
          report_issue: 'Report issue',
          report_issue_for: 'Report issue for',
          report_issue_title:
            'Pick the relevant issue from the list. Additional field information will be sent automatically.',
          report_issue_placeholder: 'What more can clarify the issue?',
          report_issue_error:
            'An issue occurred while reporting, try again later',
          report_issue_success_message: 'The report was created successfully',
          report_issue_view_on_monday: 'View on Monday',
          report_issue_sensor_issues: 'Sensor Issues',
          report_issue_field_issues: 'Field Issues',
          delete_my_data: 'Delete My Data',
          delete_data_warning_grace:
            'This action will schedule permanent removal of all your data from the system. You will have {{days}} days to cancel this request before the data is permanently deleted.',
          delete_data_confirm: 'Are you sure you want to delete all your data?',
          delete_data_success_grace:
            'Your data deletion request has been submitted. Your data will be permanently removed in {{days}} days.',
          delete_data_confirmation_email:
            'A confirmation email has been sent to your email address. You can cancel this request within the grace period by contacting support.',
          delete_data_button: 'Delete All My Data',
          delete_data_confirm_button: 'Yes, Delete My Data',
          delete_data_error:
            'An error occurred while deleting your data. Please try again later.',
          delete_data_enter_password: 'Enter your password to confirm',
          delete_data_password_required: 'Password is required to proceed',
          delete_data_reason_label:
            'Why are you deleting your data? (optional)',
          delete_data_reason_select: 'Select a reason...',
          delete_data_reason_no_longer_need: 'I no longer need the service',
          delete_data_reason_privacy_concerns: 'Privacy concerns',
          delete_data_reason_switching_service: 'Switching to another service',
          delete_data_reason_too_complex: 'The service is too complex',
          delete_data_reason_other: 'Other',
          high_pressure: 'High pressure',
        },
      },
      pt: {
        translations: {
          new_planner_title: 'Recomendação de irrigação',
          no_irrigation_planning_this_week:
            'Irrigação não necessária nesse momento',
          new_planner_no_recommendation_available_indication:
            'Recomendação de irrigação não disponível - dados ausentes',
          new_planner_recommendation_irrigate: 'Irrigar',
          new_planner_recommendation_amount: 'Quantidade',
          new_planner_recommendation_frequency: 'Frequência',
          new_planner_recommendation_times_a_week: 'Vezes por semana',
          new_planner_recommendation_every: 'A cada',
          report_issue_success_message: 'O relatório foi criado com sucesso',
          report_issue_view_on_monday: 'Ver no Monday',
          new_planner_recommendation_days: 'Dias',
          new_planner_recommendation_format_every_day: 'todos os dias',
          day: 'dia',
          new_planner_recommendation_daily_return: 'Diário',
          new_planner_recommendation_daily_return_avg: 'média',
          new_planner_this_week: 'Esta semana',
          new_planner_next_week: 'Próxima semana',
          new_planner_previous_week: 'Semana passada',
          new_planner_previuos_week: 'Semana anterior',
          new_planner_feedback: 'Essa recomendação é útil?',
          new_planner_rain_excluded:
            'As previsões de chuva são excluídas para garantir um planejamento confiável',
          new_planner_feedback_thanks:
            'Obrigado por compartilhar esta informação conosco',
          gauge_low_v2: 'Baixo',
          gauge_good_v2: 'Bom',
          gauge_critcal_v2: 'Crítico',
          gauge_no_data_v2: 'Sem dados',
          gauge_title_v2: 'Estado hídrico da cultura',
          gauge_title_v3: 'Disponibilidade de água às plantas',
          gauge_high_v3: 'Alta',
          gauge_medium_v3: 'Médio',
          gauge_low_v3: 'Baixo',
          done_button: 'Finalizado',
          timeframe_name: 'Nome do período',
          edit_field_pre_season_irrigation_start_date:
            'Data de início da irrigação pré-temporada',
          login_registration_confirmation_message:
            'Por favor, confirme sua inscrição clicando no link de confirmação enviado para o seu email.',
          login_registration_after_confirmation_message:
            'Após a confirmação, vá até',
          login_registration_after_confirmation_message_2: 'e Entrar.',
          login_enter_your_email: 'Insira seu endereço de email',
          support_leave_message: 'Deixe-nos uma mensagem',
          support_name_label: 'Seu nome',
          support_email_label: 'Endereço de email',
          support_optional: 'opcional',
          support_required: 'obrigatório',
          support_name_placeholder: 'Insira seu nome',
          support_help_message_title: 'Como podemos ajudar?',
          support_attachments: 'Anexos',
          support_add_files: 'Adicione até {{count}} arquivos',
          support_drop_files: 'Solte os arquivos aqui',
          support_remove_attachment: 'Remover anexo',
          support_minimize_widget: 'Minimizar widget',
          support_message_sent: 'Mensagem enviada com sucesso',
          support_message_failed: 'Algo deu errado',
          support_sending: 'Enviando...',
          support_login_required:
            'Você precisa estar conectado para enviar uma mensagem de suporte.',
          login_enter_your_password: 'Insira sua senha',
          login_enter_a_valid_email: 'Insira uma conta de email válida',
          login_enter_a_valid_confirmation_code:
            'Insira um código de confirmação válido',
          login_forgot_password: 'Esqueceu sua senha?',
          login_enter_verification_code_message:
            'Insira o código de verificação recebido no seu email.',
          login_enter_confirmation_code_message:
            'Insira o código de confirmação recebido no seu email.',
          login_enter_confirmation_code: 'Insira o código de confirmação',
          confirmation_code: 'Código de confirmação',
          login_new_password: 'Nova senha',
          login_enter_a_valid_password: 'Insira uma senha válida',
          login_dont_have_account_message: 'Não possui uma conta?',
          login_sign_up: 'Increver-se',
          login_enter_first_name: 'Insira seu primeiro nome',
          login_enter_last_name: 'Insira seu sobrenome',
          login_enter_phone_number: 'Insira seu número de telefone',
          login_password_limitation_message:
            'Sua senha deverá possuir no mínimo 8 caracteres, sendo pelo menos uma letra maiúscula e uma letra minúscula.',
          account_first_name_invalid_data_message:
            'Insira um primeiro nome válido',
          account_last_name_invalid_data_message: 'Insira um sobrenome válido',
          account_phone_number_invalid_data_message:
            'Insira um número de telefone válido',
          account_email_invalid_data_message:
            'Insira um endereço de email válido',
          account_notifications: 'Deseja receber notificações de irrigação?',
          loading: 'Carregando...',
          kc_developments: 'Desenvolvimento',
          kc_auto_generate: 'Gerar automaticamente',
          kc_crop_type_invalid_data_message: 'Insira uma cultura válida',
          kc_variety: 'Variedade',
          kc_variety_invalid_data_message: 'Insira uma variedade válida',
          kc_feature: 'Característica ',
          kc_feature_invalid_data_message: 'Insira uma característica válida',
          kc_sow_date: 'Data de plantio',
          kc_sow_date_invalid_data_message: 'Insira uma data de plantio válida',
          kc_kc_table: 'Tabela de Kc',
          kc_by_month: 'Mensal',
          kc_by_growth_phase: 'Fases de crescimento',
          kc_add_development_phase: 'Adicionar uma fase de desenvolvimento',
          kc_phase_title_placeholder: 'Inserir título da fase de crescimento',
          kc_first_phase_starts: 'Primeira fase inicia-se em',
          edit_field_choose_area_message: 'Demarque a área da lavoura',
          edit_field_finish_open_edit_message:
            'Conclua ou cancele a edição aberta antes de atualizar o campo',
          edit_field_field_name: 'Nome do Campo',
          edit_field_last_recommendation: 'Última recomendação',
          edit_field_no_fields: 'Nenhuma plantação a ser exibida',
          edit_field_field_name_invalid_data_message:
            'Insira um nome de plantação válido',
          edit_field_area_invalid_data_message:
            'Demarque a área de sua lavoura utilizando o menu à esquerda',
          edit_field_field_size_invalid_data_message:
            'Insira um tamanho de campo válido',
          edit_field_time_zone_invalid_message: 'Insira um fuso horário válido',
          edit_field_water_meter_sensors:
            'Sensores de Medição de Água de Irrigação',
          edit_field_installation_date: 'Data de instalação',
          edit_field_installation_date_invalid_message:
            'Insira uma data de instalação válida',
          edit_field_contract_duration: 'Dia de término do contrato',
          edit_field_contract_duration_invalid_message:
            'Duração do contrato deve ser maor que hoje',
          edit_field_delete_field_message:
            'Tem certeza que deseja excluir a plantação?',
          cluster: 'Cluster',
          meteorological_data: 'Dados Meteorológicos',
          station: 'Estação',
          distance: 'Distância',
          no_custom_station_added: 'Nenhuma estação personalizada adicionada',
          select_station: 'Selecionar estação',
          select_station_type: 'Selecionar tipo de estação',
          no_stations_found: 'Nenhuma estação encontrada',
          find_nearest_station: 'Encontrar estação mais próxima',
          add_station: 'Adicionar',
          drag_to_reorder_station: 'Arraste para reordenar',
          station_priority_hint:
            'Arraste para definir a prioridade. Os dados vêm da estação do topo; parâmetros que ela não informa vêm da seguinte.',
          nearest_station_found:
            'Estação ativa mais próxima: {{station}} ({{km}} km do campo)',
          no_station_nearby:
            'Nenhuma estação ativa com localização conhecida a menos de {{km}} km',
          remove_station: 'Remover estação',
          irrigate_command: 'Por favor, irrigue',
          get_ready_to_irrigate: 'Prepare-se para a irrigação',
          dont_irrigate_command: 'Não há necessidade de irrigação',
          stress_level_very_high: 'Nível de estresse é muito alto',
          stress_level_high: 'Nível de estresse é alto',
          stress_level_getting_low: 'Nível de estresse está reduzindo',
          stress_level_optimal: 'Nível de estresse é ótimo',
          no_recommendation_available: 'Recomendação não disponível',
          expiration_date: 'Data de expiração',
          soil_type: 'Solo',
          crop_type: 'Cultura',
          based_on: 'baseado em',
          test: 'Teste',
          dashboard_irrigation_amount: 'Lâmina de irrigação',
          dashboard_my_fields: 'Meus Campos',
          dashboard_delete_field: 'Excluir',
          dashboard_copy_field_id: 'Copiar ID',
          dashboard_copy_field_description: 'Copiar descrição do campo',
          dashboard_copied: 'Copiado',
          dashboard_edit_field: 'Editar',
          dashboard_add_field: 'Adicionar Campo',
          dashboard_new_field: 'Nova plantação',
          dashboard_loading_data_message:
            'Estamos coletando dados pelas próximas 6-8 horas',
          management_distribution_units_management:
            'Gestão das Unidades de Distribuição',
          transmitter_admin_page: 'Avaliação dos transmissores',
          search_transmitter_title: 'Buscar um Transmissor',
          search_transmitter_description:
            'Digite o ID do transmissor ou selecione um campo para visualizar o status e as métricas do transmissor.',
          transmitter_not_found:
            'Transmissor não encontrado ou ocorreu um erro.',
          error_occurred: 'Ocorreu um erro',
          retry: 'Tentar Novamente',
          detailed_data_unavailable:
            'Algumas métricas detalhadas não puderam ser carregadas.',
          latest: 'Mais Recente',
          management_admins_only: 'Apenas administradores',
          management_farming_units_management: 'Gestão das Unidades Agrícolas',
          management_delete_distribution_message:
            'Tem certeza que deseja excluir a unidade de distribuição?',
          management_manage_distribution_users_title:
            'Gestão {{Distribuição}} Usuários',
          management_enter_a_valid_username:
            'Insira um nome de usuário válido - ex. user@domain.com',
          management_enter_a_valid_distribution_name:
            'Insira um nome de distribuição válido',
          management_enter_a_valid_farming_unit_name:
            'Insira um nome de unidade agrícola válido',
          management_enter_a_valid_region: 'Insira uma região válida',
          management_farming_unit_name: 'Nome da Unidade Agrícola',
          management_farming_unit_salesforce_id: 'Salesforce ID',
          management_distribution_name: 'Nome da Unidade de Distribuição',
          time_zone: 'Fuso horário',
          tensiometers: 'Tensiômetros',
          distribution_unit: 'Unidade de Distribuição',
          farming_unit: 'Unidade Agrícola',
          field_amount: 'Número de plantações',
          region: 'Região',
          actions: 'Ações',
          close: 'Fechar',
          user: 'Usuário',
          role: 'Função',
          admin: 'Administrador',
          viewer: 'Operador',
          account: 'Conta',
          preferences: 'Preferências',
          logout: 'Sair',
          first_name: 'Primeiro nome',
          last_name: 'Sobrenome',
          phone_number: 'Número de telefone',
          email: 'Email',
          units: 'Unidades',
          area: 'Área',
          gdd: 'GDD',
          kc: 'Kc',
          kc_optimized: 'Kc otimizado',
          et0: 'ETo',
          leached: 'Lixiviado',
          plant: 'Planta',
          soil: 'Solo',
          temperature: 'Temperatura',
          weight: 'Massa',
          pressure: 'Pressão',
          length: 'Comprimento',
          volume: 'Volume',
          estimated_nitrogen_values: 'Valores estimados de nitrogênio',
          temperature_celsius: 'Celsius',
          temperature_fahrenheit: 'Fahrenheit',
          weight_kg: 'Kg',
          weight_lb: 'lb',
          weight_tonne: 'Tonelada',
          weight_short_ton: 'Tonelada curta',
          pressure_kpa: 'kPa',
          pressure_psi: 'PSI',
          pressure_cbar: 'CBar',
          pressure_mm: 'mm',
          pressure_pa: 'Pa',
          length_mm: 'mm',
          length_inch: 'Polegada',
          volume_cubic_metre: 'Metro cúbico',
          volume_gallon: 'Galão',
          volume_bushel: 'Bushel',
          volume_acre_foot: 'Acre-pé',
          volume_acre_inch: 'Acre-polegada',
          volume_megaliter: 'Megalitro',
          phase: 'Fase',
          duration: 'Duração',
          days: 'Dias',
          months_january: 'Janeiro',
          months_february: 'Fevereiro',
          months_march: 'Março',
          months_april: 'Abril',
          months_may: 'Maio',
          months_june: 'Junho',
          months_july: 'Julho',
          months_august: 'Agosto',
          months_september: 'Setembro',
          months_october: 'Outubro',
          months_november: 'Novembro',
          months_december: 'Dezembro',
          choose_date: 'Selecione a data',
          last_day: 'Último dia',
          last_week: 'Última semana',
          last_two_weeks: 'Últimas 2 semanas',
          last_month: 'Último mês',
          last_six_months: 'Últimos 6 meses',
          last_year: 'Último ano',
          max: 'Máx',
          min: 'Mín',
          pressure_boundaries: 'Limites de Pressão',
          max_date_range: 'Máx',
          supporting_data: 'Dados de apoio',
          water_stress_level: 'Nível de estresse hídrico',
          fertilization_gauge_title: 'Nível de nitrogênio',
          map_view: 'Visualização do mapa',
          serial_no: 'Número de série',
          sensor_serial_no: 'Número de série do sensor',
          sensor_latitude: 'Latitude do sensor',
          sensor_longitude: 'Longitude do sensor',
          water_meter_units: 'M³ por pulso',
          name: 'Nome',
          latitude: 'Latitude',
          longitude: 'Longitude',
          create: 'Criar',
          update: 'Atualizar',
          field: 'Plantação',
          cancel: 'Cancelar',
          delete: 'Deletar',
          ok: 'OK',
          confirmation: 'Confirmação',
          confirm: 'Confirmar',
          yes: 'Sim',
          no: 'Não',
          home: 'Início',
          change: 'Modificar',
          forgot: 'Esqueceu',
          password: 'Senha',
          login: 'Entrar',
          prefix: 'Prefixo',
          register: 'Registrar',
          settings: 'Configurações',
          amount: 'Quantidade',
          date_and_time: 'Data & Hora',
          report: 'Inserir',
          hour: 'hora',
          hours: 'horas',
          minute: 'minuto',
          minutes: 'minutos',
          report_irrigation: 'Inserir Irrigação',
          report_nitrogen: 'Inserir Nitrogênio',
          irrigation_reported_successfully: 'Irrigação inserida com sucesso',
          is_manure: 'É esterco?',
          irrigation: 'Irrigação',
          select_sensors: 'Sensores selecionados',
          select_all: 'Selecionar tudo',
          manure: 'Esterco',
          nitrogen: 'Nitrogênio',
          fertilization_history: 'Histórico de fertilização',
          water_pressure_history: 'Histórico de Potencial Hídrico',
          transmitter_id: 'Identificação do transmissor',
          transmitter_data_missing: 'Dados do transmissor ausentes',
          support_ndvi: 'Suportar NDVI?',
          i_agree_to: 'Eu concordo em',
          terms_and_conditions: 'Termos e condições',
          language: 'Idioma',
          last_update: 'Última atualização: ',
          hours_ago: 'há {0} horas',
          hour_ago: 'há {0} hora',
          day_ago: 'há {0} dia',
          days_ago: 'há {0} dias',
          days_ago_suffix: 'dias atrás',
          week_ago: '{0} semana atrás',
          weeks_ago: '{0} semanas atrás',
          today: 'hoje',
          yesterday: 'ontem',
          minute_ago: 'há {0} minuto',
          minutes_ago: 'há {0} minutos',
          ago: 'atrás',
          login_page: 'Página de Entrada',
          Sand: 'Arenoso',
          'Loamy Sand': 'Areia Franca',
          'Sandy Loam': 'Franco arenoso',
          Loam: 'Franco',
          Silt: 'Siltoso',
          'Silty Loam': 'Franco siltoso',
          'Sandy Clay Loam': 'Franco argilo arenoso',
          'Clay Loam': 'Franco argiloso',
          'Silty Clay Loam': 'Franco argilo siltoso',
          'Sandy Clay': 'Argilo arenoso',
          'Silty Clay': 'Argilo siltoso',
          Clay: 'Argiloso',
          'Mix of Peat types': 'Turfa',
          'Coconut fiber': 'Fibra de coco',
          'Mixed Tuff': 'Outros substratos orgânicos',
          last_seen: 'Última visualização',
          recent_analog_values: 'Valores analógicos recentes',
          recent_battery_values: 'Valores recentes de bateria',
          recent_c1_values: 'Valores C1 recentes',
          modem_version: 'Versão do Modem',
          modem_hardware: 'Hardware de modem',
          iccid: 'ICCID',
          sample_interval: 'Intervalo de amostragem',
          micro_version: 'Versão micro',
          date: 'Data',
          value: 'Valor',
          sim_activation:
            'SIM sendo ativado, aguarde 10 minutos antes de testar novamente',
          enter_transmitter_id: 'Insira a identificação do transmissor',
          Cabbage: 'Repolho',
          Carrot: 'Cenoura',
          Cauliflower: 'Couve-flor',
          Celery: 'Salsão',
          Lettuce: 'Alface',
          Onion: 'Cebola',
          Spinach: 'Espinafre',
          Radish: 'Rabanete',
          Eggplant: 'Berinjela',
          'Sweet pepper': 'Pimentão',
          Tomato: 'Tomate',
          Cantaloupe: 'Melão',
          Cucumber: 'Pepino',
          'Pumpkin (Winter Squash)': 'Abóbora (de inverno)',
          Squash: 'Abóbora',
          Zucchini: 'Abobrinha',
          'Sweet Melon': 'Meão Doce',
          Beet: 'Beterraba',
          Cassava: 'Mandioca',
          Potato: 'Batata',
          'Sweet potato': 'Batata-doce',
          'Sugar Beet': 'Beterraba sacarina',
          Bean: 'Feijão',
          'Faba bean, broad bean': 'Feijão fava',
          'Green Gram': 'Grão de bico',
          Cowpea: 'Feijão fradinho',
          'Peanut (Groundnut)': 'Amendoim',
          Lentil: 'Lentilha',
          Pea: 'Ervilha',
          Soybean: 'Soja',
          Artichoke: 'Alcachofra',
          Asparagus: 'Aspargo',
          Cotton: 'Algodão',
          Flax: 'Linhaça',
          'Castorbean (Ricinus)': 'Castorbean (Ricinus)',
          Safflower: 'Cártamo',
          Sesame: 'Sésame',
          Sunflower: 'Girassol',
          Barley: 'Cevada',
          Oat: 'Aveia',
          Wheat: 'Trigo',
          Maize: 'Milho',
          Millet: 'Milheto',
          Sorghum: 'Sorgo',
          Rice: 'Arroz',
          Alfalfa: 'Alfafa',
          Bermuda: 'Grama bermuda',
          Sudan: 'Grama Sudan',
          Sugarcane: 'Cana-de-açúcar',
          Banana: 'Banana',
          Pineapple: 'Abacaxi',
          Grape: 'Uva',
          Hop: 'Lúpulo',
          Citrus: 'Citrus',
          Olive: 'Oliveira',
          Pistachio: 'Pistache',
          Walnut: 'Noz',
          'Cattails, Bulrush': 'Taboa',
          Mango: 'Manga',
          Grapefruit: 'Toranja',
          Garden: 'Plantas de Jardim',
          Grass: 'Grama',
          'Genus Citrus': 'Citrus (Gênero)',
          Avocado: 'Abacate',
          Coffee: 'Café',
          Corn: 'Milho',
          Lychee: 'Lichia',
          'Peach, Nectarine': 'Pêssego, Nectarina',
          Watermelon: 'Melancia',
          'Date Palm': 'Tâmara',
          Pomegranate: 'Romã',
          Cannabis: 'Cânhamo',
          Pepper: 'Pimenta',
          Blackberry: 'Amora',
          Strawberry: 'Morango',
          Pecan: 'Noz-pecã',
          installation_date: 'data de instalação',
          soil_water_deficit: 'Deficiência hídrica no solo',
          n_in_organic_matter: 'N na matéria orgânica',
          initial_concentrations: 'Concentrações iniciais',
          should_automate_irrigation: 'Automatize a irrigação',
          kc_harvest_date: 'Data de colheita',
          kc_harvest_date_invalid_data_message:
            'Insira uma data de colheita  válida',
          insights_tab: 'Análises',
          notifications: 'Notificações',
          location: 'Localização',
          new: '🎉 Novo!',
          download_the_app: 'Baixe o aplicativo para celular',
          take_the_app_to_the_field:
            'Leve N-Drip Connect como você para o campo',
          etc: 'ETc',
          distribution: 'Distribuição',
          sensor: 'Sensor',
          global_search_placeholder:
            'Buscar distribuições, unidades agrícolas, plantações e sensores',
          global_search_empty_hint:
            'Comece a digitar para buscar por nome ou ID',
          global_search_no_results: 'Nenhum resultado encontrado',
          global_search_more_results:
            'Exibindo os primeiros {{shown}} de {{total}} resultados',
          global_search_recent_fields: 'Plantações recentes',
          global_search_hint_navigate: 'Navegar',
          global_search_hint_select: 'Selecionar',
          'my fields': 'Minhas lavouras',
          sensor_batch: 'Lote de sensores',
          transmission_interval: 'Intervalo de transmissão',
          start: 'Início',
          end: 'Fim',
          discharge: 'Vazão',
          'recent wfr samples': 'Valores recentes do contador de água ',
          'choose map': 'Escolha no mapa',
          day_sunday: 'Domingo',
          day_monday: 'Segunda-feira',
          day_tuesday: 'Terça-feira',
          day_wednesday: 'Quarta-feira',
          day_friday: 'Sexta-feira',
          day_saturday: 'Sábado',
          planning: 'Planejamento',
          field_view: 'Vista do Campo',
          farm_view: 'Vista da Fazenda',
          new_section:
            'Novidade!\nVisualize todas as informações sobre sua fazenda e irrigação em um só lugar',
          weekly_performance: 'Desempenho semanal',
          weekly_performance_tooltip:
            'Exibe os eventos de irrigação reais em comparação com a programação recomendada',
          irrigation_activity_tooltip:
            'Exibe quando a última irrigação terminou ou indica uma irrigação ativa',
          root_zone_water_potential_tooltip:
            'Exibe as medições do potencial hídrico da zona radicular, obtidas pelo sensor representativo em campo, para os últimos sete dias disponíveis',
          sort: 'Ordenar',
          advanced: 'Avançado',
          advanced_mode: 'Modo Avançado',
          unknown_field: 'Talhão Desconhecido',
          not_available: 'Não disponível',
          irrigating: 'Irrigando',
          no_data: 'Sem dados',
          plan: 'Plano',
          since_date: 'Desde {{date}}',
          flow_meter_source: 'Medidor de Vazão',
          manual_input_source: 'Entrada Manual',
          connect_sensor_source: 'Sensor Conectado',
          no_fields_available: 'Nenhum talhão disponível',
          fields: 'Talhões',
          recommendation: 'Recomendação',
          stress_level: 'Nível de Estresse',
          root_zone_wp: 'PH Zona Radicular',
          map_satellite: 'Satélite',
          map_topography: 'Topografia',
          map_streets: 'Ruas',
          ndvi_timeline: 'Linha do tempo NDVI',
          planning_days: 'Dias',
          planning_weeks: 'Semanas',
          planning_publish: 'Publicar',
          recent_errors_values: 'Valores de erros recentes',
          sim_last_event: 'Último evento do cartão SIM ',
          leaf_length: 'Comprimento foliar ',
          stress_level_no_stress: 'Sem estresse',
          next_actions: 'Próximas ações',
          tomorrow: 'Amanhã',
          later: 'Mais tarde',
          coming_soon: 'Em breve',
          no_planner_events: 'Sem ações futuras neste momento',
          history_graph: 'Gráfico histórico',
          planning_planned: 'PLANEJADO',
          planning_used: 'EXECUTADO',
          event: 'evento',
          hcl: 'HCl',
          hpo: 'HPO',
          note: 'Observação',
          planning_note_placeholder: 'Escreva aqui sua mensagem',
          sensors: 'sensores',
          valves: 'válvulas',
          type: 'tipo',
          'coming up': 'chegando',
          locate_coordinates: 'Localizar coordenadas',
          ignore_sensor_during_calculations: 'Ignorar sensor nos cálculos',
          ignore_sensor_during_calculations_and_hide:
            'Ocultar e ignorar sensor nos cálculos',
          consider_as_flow_meter: 'Consider como medidor de vazão',
          water_potential_graph: 'Gráfico de potencial hídrico',
          edit: 'Editar',
          alerts: 'Alertas',
          stop_data_collection: 'Interromper a coleta de dados',
          accumulated_water_input: 'Entrada de água acumulada',
          soil_temperature: 'Temperatura do Solo',
          soil_temperature_graph_title: 'Temperatura do Solo',
          precipitation: 'Chuva',
          water_potential: 'Potencial hídrico',
          irrigation_activity: 'Atividade de irrigação',
          root_zone_water_potential: 'Potential hídrico na zona radicular',
          minimum: 'Mín',
          maximum: 'Máx',
          max_bigger_than_min: 'Valor máximo deve ser maior que o valor mínimo',
          min_smaller_than_max:
            'Valor máximo deve ser menor que o valor mínimo',
          moderator: 'Moderador',
          designed_pressure: 'Pressão estimada',
          field_size: 'Tamanho do campo',
          duplicate_field: 'duplicar campo',
          duplicate: 'duplicar',
          offset: 'Offset',
          days_from_sowing: 'Dias após semeadura',
          Field_details_days_in_season: 'Dias em período de safra',
          show_archived: 'Mostrar arquivados',
          events_list: 'Lista de eventos',
          notes: 'Comentários',
          week_total: 'Total semanal',
          season_total: 'Total safra',
          no_reported: 'Nenhum evento adicionado',
          report_event: 'Adicionar evento',
          save: 'salvar',
          rain: 'Chuva',
          starting_time: 'hora de início',
          fertilization: 'fertilização',
          reported: 'Adicionados',
          plant_height: 'Altura de planta',
          fert_tank_height: 'Nível do tanque de fertilização',
          Fert_tank_volume: 'Volume do tanque de fertilização',
          allow_notifications: 'Permitir notificações',
          notifications_channels: 'Em quais canais você será notificado',
          event_type: 'Tipo de evento',
          push: 'Ativar',
          recommendations: 'Recomendações',
          field_notifications:
            'Quais notificações você receberá para cada campo',
          none: 'Nenhum',
          notifications_phase:
            'Controlar os tipos de notificação e canais pelos quais serei notificado, por campo',
          alerts_tooltip:
            'Os alertas sinalizam eventos adversos que exigem ação imediata para proteção das lavouras',
          recent_connectivity_values: 'Valores recentes de conectividade',
          alerts_message_continuous_irrigation_notification_center_title:
            'Alerta de Irrigação contínua - fieldX.',
          alerts_message_continuous_irrigation_notification_center_body:
            'Detectamos irrigação contínua há mais de 2 dias para o campo. Para proteção das lavouras, recomendamos verificar se o campo está sendo overirrigado.',
          low_pressure_event_hint: 'Pressão baixa detectada nesta irrigação',
          high_pressure_event_hint: 'Pressão alta detectada nesta irrigação',
          low_pressure_detected_value: 'Pressão baixa detectada: {{value}}',
          high_pressure_detected_value: 'Pressão alta detectada: {{value}}',
          alerts_message_low_pressure_notification_center_title:
            'Pressão baixa detectada no fieldX',
          alerts_message_low_pressure_notification_center_body:
            'A pressão medida no fieldX ficou abaixo do mínimo definido para este sensor, o que pode reduzir a água aplicada e afetar sua distribuição no campo. Recomendamos verificar os filtros, as válvulas e as tubulações.',
          alerts_message_high_pressure_notification_center_title:
            'Pressão alta detectada no fieldX',
          alerts_message_high_pressure_notification_center_body:
            'A pressão medida no fieldX ficou acima do máximo definido para este sensor, o que pode sobrecarregar o sistema de irrigação e afetar a distribuição da água. Recomendamos verificar a regulagem de pressão e as válvulas a jusante.',
          alerts_message_sensor_extreme_dry_conditions_notification_center_title:
            'Condições extremas de seca detectadas no campo - Dados recebidos do sensorX',
          alerts_message_long_dry_period_notification_center_title:
            'Longo período sem irrigação - Recomendamos a irrigação do fieldX',
          alerts_message_sensor_extreme_dry_conditions_notification_center_body:
            'Os dados recebidos pelo sensorX indicam condição extremamente seca no campo.Para assegurar dados precisos e proteção das lavouras, recomendamos verificar o plano de irrigação e o sistema de irrigação ao redor do sensor.',
          alerts_message_long_dry_period_notification_center_body:
            'O fieldX não recebe água há 10 dias, o que pode resultar em estresse hídrico. Para proteção das lavouras, recomendamos irrigar o campo seguindo seu plano de irrigação N-Drip.',
          alerts_message_drying_trend_notification_center_title:
            'Tendência de ressecamento detectada no fieldX',
          alerts_message_wetting_trend_notification_center_title:
            'Tendência de umedecimento detectada no fieldX',
          alerts_message_drying_trend_notification_center_body:
            'Observamos tendência decrescente no potencial hídrico do fieldX, abaixo do nível recomendado. Para otimização das lavouras, revise e ajuste seu plano de irrigação de acordo com as recomendações de N-Drip.',
          alerts_message_wetting_trend_notification_center_body:
            'Observamos tendência crescente do potencial hídrico no fieldX, acima do nível recomendado. Para otimização das lavouras, revise e ajuste seu plano de irrigação atual de acordo com as recomendações de N-Drip.',
          alerts_message_excessive_heat_notification_center_title:
            'Temperatura do ar elevada',
          alerts_message_excessive_heat_notification_center_body:
            'Há a previsão de ocorrência de temperatura do ar elevada para a fieldX para os próximos dias. Para otimização das lavouras revise e ajuste seu plano de irrigação atual de acordo com nossas recomendações atualizadas.',
          alerts_message_extreme_cold_notification_center_title:
            'Alerta de Onda de Frio',
          alerts_message_extreme_cold_notification_center_body:
            'Uma onda de frio significativa está prevista para ocorrer na área do fieldX nos próximos dias. Para proteger sua lavoura dos danos causados pela geada, revise e ajuste seu plano de irrigação de acordo com as nossas recomendações atualizadas.',
          notifications_welcome_message_title:
            'Bem-vindo ao novo painel de notificações',
          notifications_welcome_message_body:
            'Fique por dentro de eventos importantes atuais e esperados em suas lavouras no desktop e dispositivos móveis',
          alerts_message_dryland_long_dry_period_notification_center_title:
            'Longo período seco detectado',
          alerts_message_dryland_long_dry_period_notification_center_body:
            'O fieldX não recebe água há 10 dias, o que pode resultar em estresse hídrico.',
          alerts_message_dryland_sensor_exterme_dry_notification_center_title:
            'Condições extremas de seca detectadas no campo - Dados recebidos do sensorX',
          alerts_message_dryland_sensor_exterme_dry_notification_center_body:
            'Os dados recebidos pelo sensorX indicam condição extremamente seca no campo.',
          alerts_message_dryland_drying_trend_notification_center_title:
            'Tendência de seca detectada no seu campo',
          alerts_message_dryland_drying_trend_notification_center_body:
            'Observamos tendência decrescente no potencial hídrico do fieldX, o que pode resultar em estresse hídrico',
          alerts_message_dryland_wetting_trend_notification_center_title:
            'Tendência de umedecimento detectada no seu campo',
          alerts_message_dryland_wetting_trend_notification_center_body:
            'Observamos tendência crescente no potencial hídrico do fieldX, o que pode resultar em estresse hídrico',
          alerts_message_dryland_excessive_heat_notification_center_title:
            'Alerta de Onda de Calor',
          alerts_message_dryland_excessive_heat_notification_center_body:
            'Uma onda de calor significativa está prevista para ocorrer na área do fieldX nos próximos dias.',
          alerts_message_dryland_extreme_cold_notification_center_title:
            'Alerta de Onda de Frio',
          alerts_message_dryland_extreme_cold_notification_center_body:
            'Uma onda de frio significativa está prevista para ocorrer na área do fieldX nos próximos dias.',
          alerts_message_dryland_ndvi_notification_center_title:
            'Redução da atividade vegetativa',
          alerts_message_dryland_ndvi_notification_center_body:
            'Análises recentes do histórico de imagens de NDVI revelaram uma redução significativa no crescimento vegetativo no fieldX. Para otimizar a saúde de sua lavoura, revise suas práticas atuais de irrigação.',
          no_notifications: 'No momento não há notificações',
          load_more: 'Carregar mais',
          all_fields: 'Todos os campos',
          current_field: 'Campo atual',
          planner_days_shorts_sun: 'Dom',
          planner_days_shorts_mon: 'Seg',
          planner_days_shorts_tue: 'Ter',
          planner_days_shorts_wed: 'Qua',
          planner_days_shorts_thu: 'Qui',
          planner_days_shorts_fri: 'Sex',
          planner_days_shorts_sat: 'Sab',
          shorts_months_january: 'Jan',
          shorts_months_february: 'Fev',
          shorts_months_march: 'Mar',
          shorts_months_april: 'Abr',
          shorts_months_may: 'Mai',
          shorts_months_june: 'Jun',
          shorts_months_july: 'Jul',
          shorts_months_august: 'Ago',
          shorts_months_september: 'Set',
          shorts_months_october: 'Out',
          shorts_months_november: 'Nov',
          shorts_months_december: 'Dez',
          dont_show_again: 'Não mostrar novamente',
          notifications_settings: 'Configurações de notificação',
          read_more: 'Leia mais',
          show_less: 'Mostrar menos',
          distribution_menu_select: 'Selecionar distribuição',
          farming_unit_menu_select: 'Selecionar Unidade Agrícola',
          field_menu_select: 'Selecionar campo',
          recent_field: 'Campo recente',
          discharge_test: 'Teste de Vazão',
          planner_season_start: 'Início da safra',
          planner_season_end: 'Fim da safra',
          planner_growth_phase_initial: 'Inicial',
          planner_growth_phase_development: 'Desenvolvimento',
          planner_growth_phase_middle: 'Médio',
          planner_growth_phase_late: 'Final',
          planner_add_event_button: 'Adicionar evento',
          planner_water_treatment: 'Tratamento de água',
          planner_add_button: 'Adicionar',
          create_planner_item: 'Adicionar novo evento ',
          update_planner_item: 'Atualizar evento',
          planner_start_time: 'Hora de início',
          dashboard_move_to_archive: 'Mover para o arquivo',
          dashboard_unarchive: 'Desarquivado',
          Insights_title_county: 'Condado',
          Insights_group_by: 'Agrupado por',
          edit_field_tank_type: 'Tipo do reservatório de água',
          edit_field_recommendation_display: 'Mostrar dados de irrigação em',
          recommendation_display_duration: 'Duração',
          recommendation_display_amount: 'Quantidade',
          edit_field_recommendation_display_description:
            'Duração é o padrão para sistemas N-Drip, Seepage, Flood e Furrow; Quantidade para os demais. Alterar o tipo de irrigação redefine esta opção para o padrão do sistema.',
          edit_field_measured_irrigation_rate: 'Taxa de irrigação medida',
          edit_field_custom_irrigation_rate: 'Customizar taxa de irrigação',
          edit_field_representative_input_checkbox:
            'Utilize os valores medidos de taxa de irrigação quando disponíveis. Isso impactará o planejamento de irrigação',
          wtr_reported_successfully: 'Tratamento de água reportado com sucesso',
          kc_phases_stress_checkbox: 'Aplicar estresse',
          kc_phases_stress_tooltip:
            'Iniciar um período planejado de estresse hídrico de acordo com a seguinte redução percentual na ETc',
          edit_field_irrigation_timeframe_source_soil:
            'limitação pelo tipo de solo',
          edit_field_irrigation_timeframe_source_irrigation_rate:
            'taxa de irrigação',
          edit_field_irrigation_timeframe_source_user: 'definido por usuário',
          edit_field_irrigation_timeframe_tooltip: 'Limitação original:',
          source: 'Origem',
          discharge_result_exceeding_hint:
            'O resultado do teste diverge da curva de tendência da vazão',
          Timeframe_no_end_date: 'Até novo aviso',
          Farming_unit_entity_basic_info: 'Informações básicas',
          add_new_button: 'Adicionar novo',
          WT_protocol_edit_field_water_properties_section_title:
            'Propriedades da água',
          WT_protocol_edit_field_water_source: 'Fonte de água',
          WT_protocol_edit_field_water_conveyance: 'Transporte',
          WT_protocol_edit_field_water_analysis_section_title:
            'Análise de água',
          WT_protocol_edit_field_water_analysis_section_subtitle:
            'Ver intervalos de recomendação em cada célula',
          WT_protocol_edit_field_water_analysis_table_materials: 'Materiais',
          WT_protocol_edit_field_water_analysis_table_score: 'Pontuação',
          WT_protocol_edit_field_water_analysis_table_low: 'Baixo',
          WT_protocol_edit_field_water_analysis_table_medium: 'Médio',
          WT_protocol_edit_field_water_analysis_table_high: 'Alto',
          WT_protocol_edit_field_water_analysis_table_organic: 'Orgânico',
          WT_protocol_edit_field_water_analysis_table_calc: 'Cálculo',
          WT_protocol_edit_field_water_analysis_table_fe: 'Ferro',
          WT_protocol_edit_field_material_concentrations:
            'Concentração dos materiais',
          WT_protocol_edit_field_acid_titration: 'Titulação ácida',
          Farming_unit_entity_tooltip:
            'Elementos desabilitados podem ser editados a partir da unidade agrícola',
          WT_timing_recommendation_after_irrigation_starts:
            'Após 30min de irrigação',
          WT_timing_recommendation_last_hour: 'Última hora de irrigação',
          Fert_sensor_fertlization_type: 'Tipo de fertilizante',
          fertilizer_meter_id: 'Identificação do medidor de fertilizante',
          add_fertilizer: 'Adicionar fertilizante',
          Farming_unit_entity_all: 'Todas',
          basic_info: 'Información basica',
          Edit_field_planner_dynamic_update_title:
            'Permitir atualizações dinâmicas',
          Edit_field_planner_dynamic_update_description:
            'As recomendações serão afetadas por mudanças na irrigação a qualquer momento.',
          KC_phases_title: 'Fase de crescimento',
          KC_phases_title_pre_season: 'Pré-safra',
          KC_phases_title_in_between_seasons: 'Entressafra',
          KC_phases_season_end: 'Fim de safra',
          KC_phases_phase_tooltip_start: 'Início',
          KC_phases_phase_tooltip_end: 'Fim',
          KC_phases_button_save: 'Salvar',
          KC_phases_button_reset: 'Reiniciar',
          KC_phases_stress_inidication: 'Irrigação com déficit controlado',
          KC_phases_button_edit: 'Editar',
          KC_phases_fast_flow: 'Configurar fase atual',
          KC_phases_now_indication: 'Agora',
          KC_phases_estimated_short: 'Est.',
          KC_phases_estimated_season_end: 'Provável fim de safra',
          KC_phases_edit_mode_default_title:
            'Clique na fase para ajustar sua duração',
          kc_phases_error_message:
            'O valor adicionado está em conflito com outras variáveis ',
          edit_field_timeframe_constraint_first_day: 'Primeiro dia da semana',
          edit_field_timeframe_constraint_season_target:
            'Meta de irrigação sazonal',
          edit_field_timeframe_constraint_weekly_mode:
            'Semanal (máximo de x vezes por semana)',
          edit_field_timeframe_constraint_interval_mode:
            'Intervalo (pelo menos a cada x dias)',
          edit_field_planner_type_no_planner: 'Sem planejamento',
          edit_field_planner_type_by_day: 'Recomendação diária',
          edit_field_planner_type_by_week: 'Recomendação semanal',
          edit_field_planner_no_irrigation: 'Sem irrigação',
          edit_field_planner_changes_message_first_day_body:
            'As recomendações serão afetadas pela mudança do primeiro dia da semana',
          edit_field_planner_changes_message_mode_body:
            'As recomendações serão afetadas pela mudança do modo de irrigação',
          select_graphs: 'Selecionar gráficos',
          accumulated_graph_baseline_recommendation_more_info_description:
            'ETc baseada no modelo da cultura (ETo x Kc), ajustada para o seu sistema de irrigação',
          accumulated_graph_adaptive_recommendation_more_info_description:
            'ETc baseada no kc otimizado, ajustada para o seu sistema de irrigação',
          accumulated_graph_title_baseline_recommendation:
            'Recomendação de referência',
          accumulated_graph_title_adaptive_recommendation:
            'Recomendação adaptada',
          field_list_title_: 'Lista de campos',
          soil_temperature_values:
            'Temp do solo diária média, max e última hora',
          report_issue: 'Reportar problema',
          report_issue_for: 'Reportar problema para',
          report_issue_title:
            'Selecione o problema relevante na lista. Informações adicionais sobre o campo serão enviadas automaticamente.',
          report_issue_placeholder:
            'O que mais pode ajudar a esclarecer o problema?',
          report_issue_error:
            'Ocorreu um error ao enviar o relatório. Tente novamente mais tarde.',
          report_issue_sensor_issues: 'Problemas do sensor',
          report_issue_field_issues: 'Problemas do campo',
          delete_my_data: 'Excluir Meus Dados',
          delete_data_warning_grace:
            'Esta ação agendará a remoção permanente de todos os seus dados do sistema. Você terá {{days}} dias para cancelar esta solicitação antes que os dados sejam excluídos permanentemente.',
          delete_data_confirm:
            'Tem certeza de que deseja excluir todos os seus dados?',
          delete_data_success_grace:
            'Sua solicitação de exclusão de dados foi enviada. Seus dados serão removidos permanentemente em {{days}} dias.',
          delete_data_confirmation_email:
            'Um e-mail de confirmação foi enviado para o seu endereço de e-mail. Você pode cancelar esta solicitação dentro do período de carência entrando em contato com o suporte.',
          delete_data_button: 'Excluir Todos os Meus Dados',
          delete_data_confirm_button: 'Sim, Excluir Meus Dados',
          delete_data_error:
            'Ocorreu um erro ao excluir seus dados. Tente novamente mais tarde.',
          delete_data_enter_password: 'Digite sua senha para confirmar',
          delete_data_password_required: 'A senha é obrigatória para continuar',
          delete_data_reason_label:
            'Por que você está excluindo seus dados? (opcional)',
          delete_data_reason_select: 'Selecione um motivo...',
          delete_data_reason_no_longer_need: 'Não preciso mais do serviço',
          delete_data_reason_privacy_concerns: 'Preocupações com privacidade',
          delete_data_reason_switching_service: 'Mudando para outro serviço',
          delete_data_reason_too_complex: 'O serviço é muito complexo',
          delete_data_reason_other: 'Outro',
          high_pressure: 'Alta pressão',
          height: 'Altura',
          metric_india: 'Metrico (India)',
          metric_israel: 'Metrico (Israel)',
          metric_australia: 'Metrico (Australia)',
          metric: 'Metrico',
          imperial: 'Imperial',
          unit_system: 'Sistema de unidades',
          recommendations_unit: 'Unidade de recomendacoes',
          none_default: 'Nenhum - Padrao',
          no_recommendation: 'Sem Recomendacao',
          support_planner: 'Planejador de Suporte',
          activity_dates: 'Datas de atividade',
          fertilization_reported_successfully:
            'Fertilizacao Reportada com Sucesso',
          rain_reported_successfully: 'Chuva Reportada com Sucesso',
          day_thursday: 'Quinta-feira',
          crop_water_availability: 'Disponibilidade de\nAgua para a Cultura',
          water_availability_high: 'Alta',
          water_availability_medium: 'Media',
          water_availability_low: 'Baixa',
          water_availability_no_data: 'Sem Dados',
          ndvi_layer: 'Camada NDVI',
          farm_map: 'Mapa da fazenda',
          field_details: 'Detalhes do campo',
          select_a_field_to_view_details:
            'Selecione um campo para ver o gráfico de potencial hídrico',
          select_a_field_to_view_its_details:
            'Selecione um campo para ver seus detalhes',
          date_chip_1d: '1D',
          date_chip_1w: '1S',
          date_chip_2w: '2S',
          date_chip_1m: '1M',
          date_chip_6m: '6M',
          date_chip_1y: '1A',
          graphs: 'Gráficos',
          map: 'Mapa',
          previous: 'Anterior',
          next: 'Próximo',
          field_name: 'Nome do Campo',
          events: 'eventos',
          notify: 'notificar',
          irrigation_system: 'Sistema de Irrigacao',
          irrigation_type: 'Tipo de Irrigacao',
          irrigation_rate: 'Taxa de Irrigacao',
          irrigation_time_frames: 'Intervalos de Irrigacao',
          define_time_frames: 'Defina os intervalos disponiveis para irrigacao',
          start_day: 'Dia de inicio',
          start_hour: 'Hora de inicio',
          end_hour: 'Hora de termino',
          time_frame_conflict:
            'O intervalo selecionado conflita com um intervalo existente',
          select_different_hour: 'Por favor, selecione um horario diferente',
          select_different_day: 'Por favor, selecione um dia diferente',
          no_time_frames: 'Nao ha restricoes de intervalos de irrigacao',
          for_this_field: 'para este campo no momento',
          petiole: 'Peciolo',
          updated: 'Atualizado',
          last_synced: 'Última sincronização:',
          not_yet_set: 'Ainda nao definido',
          missing_values: 'Valores estao faltando',
          start_date: 'Data de inicio',
          end_date: 'Data de termino',
          fertigation_concentrations: 'Concentracoes de fertirrigacao',
          no_fertigation_concentrations_message:
            'Nao ha concentracoes de fertirrigacao',
          sensor_type: 'Tipo de sensor',
          sensor_sub_type: 'Subtipo de sensor',
          alphabetic: 'Alfabetico',
          sort_by: 'Ordenar por',
          sort_alphabetic: 'Alfabetico',
          sort_crop_availability: 'Disponibilidade de agua da cultura',
          sort_last_irrigation_new_old: 'Ultima irrigacao (Recente → Antigo)',
          sort_last_irrigation_old_new: 'Ultima irrigacao (Antigo → Recente)',
          sort_last_irrigation_duration_short_long:
            'Ultima irrigacao (Mais curta → Mais longa)',
          sort_last_irrigation_duration_long_short:
            'Ultima irrigacao (Mais longa → Mais curta)',
          sort_weekly_performance_high_low: 'Desempenho semanal (Alto → Baixo)',
          sort_weekly_performance_low_high: 'Desempenho semanal (Baixo → Alto)',
          Almond: 'Amendoa',
          Apple: 'Maca',
          Arugula: 'Rucula',
          Blueberry: 'Mirtilo',
          Broccoli: 'Brocolis',
          Fig: 'Figo',
          Garlic: 'Alho',
          Guayule: 'Guaiule',
          Jojoba: 'Jojoba',
          Kiwi: 'Kiwi',
          Loquat: 'Nespera',
          Mandarin: 'Tangerina',
          Moringa: 'Moringa',
          Nectarine: 'Nectarina',
          Orange: 'Laranja',
          Peach: 'Pessego',
          Peony: 'Peonia',
          Raspberry: 'Framboesa',
          Planner: 'Planejador',
          Irrigated: 'Irrigado',
          search_by_field: 'Buscar Por Campo',
          free_search: 'Busca Livre',
          transmitters: 'Transmissores',
          week: 'Semana',
          season: 'Safra',
          transmitter_name: 'Nome do Transmissor',
          details: 'detalhes',
          select_water_input: 'Selecione a Entrada de Agua',
          next_day: 'Proximo dia',
          crop_management: 'Gerenciamento de Culturas',
          add_new_crop: 'Adicionar Nova Cultura',
          edit_parameters: 'Editar Parametros',
          select_or_enter_crop_type: 'Selecione ou insira o tipo de cultura',
          select_or_enter_variety: 'Selecione ou insira a variedade',
          enter_sub_variety: 'Insira a subvariedade (opcional)',
          select_or_enter_feature: 'Selecione ou insira a caracteristica',
          select_crop: 'Selecione a cultura...',
          phenological_phases: 'Fases Fenologicas',
          gdd_parameters: 'Parametros GDD',
          yield_parameters: 'Parametros de Rendimento',
          fields_using_crop: 'Campos Usando Esta Cultura',
          permission_hint:
            'Mostrando apenas campos que voce tem permissao para visualizar',
          no_fields_found:
            'Nenhum campo encontrado usando esta configuracao de cultura',
          select_crop_hint:
            'Selecione um tipo de cultura para visualizar e editar parametros',
          loading_crop_data: 'Carregando dados da cultura...',
          add_phase: 'Adicionar Fase',
          duration_days: 'Duracao (Dias)',
          duration_gdd: 'Duracao (GDD)',
          is_development: 'Em Desenvolvimento',
          stress_active: 'Estresse Ativo',
          stress_factor: 'Fator de Estresse',
          inherited: 'Herdado',
          crop_updated_successfully: 'Cultura atualizada com sucesso',
          crop_update_failed: 'Falha ao atualizar cultura',
          crop_added_successfully: 'Cultura adicionada com sucesso',
          crop_add_failed: 'Falha ao adicionar cultura',
          crop_key_already_exists: 'Esta chave de cultura já existe',
          number_of_fields: 'Numero de campos',
          total_area: 'Area total',
          total_water_usage: 'Uso total de agua',
          total_fertilizers_usage: 'Uso total de fertilizantes',
          total_nitrogen_leached: 'Total de nitrogenio lixiviado',
          crop_types: 'Tipos de cultura',
          measurement: 'medicao',
          containing: 'contendo',
          no_cluster: 'Sem Cluster',
          selected_field_only: 'Somente campo selecionado',
          farming_type: 'Tipo de cultivo',
          fert_tank: 'Tanque de fertilizante',
          calibration_data: 'Dados de calibracao',
          recommendations_tooltip:
            'Recomendacoes sao insights que ajudam a otimizar a produtividade e melhorar a tomada de decisoes',
          login_enter_your_email_forgot_password:
            'Insira seu e-mail e enviaremos um codigo para redefinir sua senha:',
          alerts_message_low_tank_fert_notification_center_title:
            'Nivel baixo de fertilizante detectado em fieldX',
          alerts_message_low_tank_fert_notification_center_body:
            'Detectamos que o nivel de fertilizante no tanque em fieldX atingiu o limite minimo de 10% da altura operacional do tanque. Por favor, providencie o reabastecimento do tanque para garantir a continuidade da fertilizacao das culturas.',
          country: 'Pais',
          monday_id: 'ID Monday',
          delete_item_title: 'O item sera excluido',
          delete_item_text:
            'Esta acao nao pode ser revertida e os dados serao perdidos',
          average: 'Media',
          seconds: 'seg',
          event_delete_successfully: 'O evento foi excluido com sucesso',
          reported_successfully: 'O teste foi reportado com sucesso',
          report_unsuccessfully:
            'O evento nao pode ser reportado neste momento. Por favor, tente novamente mais tarde',
          event_delete_unsuccessfully:
            'O evento nao pode ser excluido neste momento, por favor tente novamente mais tarde',
          wtr_checkbox: 'Incluir tratamento de agua',
          WT_protocol_edit_field_HPO_concentrations: 'Concentracoes de HPO',
          KC_phases_season_ended: 'Safra encerrada',
          installation_depth: 'Profundidade',
          edit_field_timeframe_no_frequnecy_constraint:
            'Se nenhum intervalo for definido, o planejador executara todos os dias',
          add_time_frames: 'Adicione restricoes de intervalo para ve-las aqui',
          assumption: 'Premissa',
          issue: 'Problema',
          extract_sensor: 'Extrair Sensor',
          select_assumption: 'Selecione a premissa',
          select_sensor: 'Selecione o sensor',
          comment: 'Comentario',
          reporting: 'Reportando...',
          air_burst: 'Estouro de Ar',
          bad_values: 'Valores Incorretos',
          no_transmission: 'Sem Transmissao',
          low_pressure_detected: 'Baixa pressao detectada',
          high_pressure_detected: 'Alta pressao detectada',
          long_dry_period: 'Periodo seco prolongado',
          drying_trend: 'Tendencia de secagem',
          wetting_trend: 'Tendencia de umidificacao',
          sensor_not_responding_to_irrigation:
            'Sensor nao esta respondendo a irrigacao',
          missed_irrigation: 'Irrigacao perdida',
          continuous_irrigation: 'Irrigacao continua',
          select_placeholder: 'Selecione...',
        },
      },
      zh: {
        translations: {
          new_planner_title: '灌溉建議',
          no_irrigation_planning_this_week: '當前不需要灌溉',
          new_planner_no_recommendation_available_indication:
            '無可用建議 - 資料缺失',
          new_planner_recommendation_irrigate: '灌溉',
          new_planner_recommendation_amount: '數量',
          new_planner_recommendation_frequency: '頻率',
          new_planner_recommendation_times_a_week: '每周次數',
          new_planner_recommendation_every: '每周次數',
          new_planner_recommendation_days: '天數',
          new_planner_recommendation_format_every_day: '每天',
          new_planner_recommendation_daily_return: '每日',
          new_planner_recommendation_daily_return_avg: '平均',
          new_planner_this_week: '本周',
          new_planner_next_week: '下周',
          new_planner_previous_week: '前一周',
          new_planner_previuos_week: '前一周',
          new_planner_feedback: '你是否認爲這個建議對你有幫助？',
          new_planner_rain_excluded: '已排除降雨預報以確保計畫的可靠性',
          new_planner_feedback_thanks: '感謝同我們分享這些信息',
          gauge_low_v2: '狀態不佳',
          gauge_good_v2: '狀態優良',
          gauge_critcal_v2: '處於危險狀態',
          gauge_no_data_v2: '沒有數據',
          gauge_title_v2: 'Estado hídrico del cultivo',
          gauge_low_v3: '狀態不佳',
          done_button: '完成_按鈕',
          Edit_field_planner_dynamic_update_title: '允許動態更新',
          Edit_field_planner_dynamic_update_description:
            '灌溉變更將隨時影響建議結果',
          edit_field_custom_irrigation_rate: '客戶灌溉量',
          insights_tab: '數據匯總',
          soil_water_deficit: '土壤水份缺乏状况',
          login_registration_confirmation_message:
            '請點擊您電子郵件中收到的確認連結以完成註冊。',
          login_registration_after_confirmation_message: '確認之后，去往',
          login_registration_after_confirmation_message_2: '登錄',
          login_enter_your_email: '進入您的邮箱',
          support_leave_message: '给我们留言',
          support_name_label: '您的姓名',
          support_email_label: '电子邮件地址',
          support_optional: '可选',
          support_required: '必填',
          support_name_placeholder: '输入您的姓名',
          support_help_message_title: '我们能为您做些什么？',
          support_attachments: '附件',
          support_add_files: '最多添加 {{count}} 个文件',
          support_drop_files: '将文件拖放到此处',
          support_remove_attachment: '删除附件',
          support_minimize_widget: '最小化小工具',
          support_message_sent: '消息发送成功',
          support_message_failed: '出了点问题',
          support_sending: '发送中...',
          support_login_required: '您必须登录才能发送支持消息。',
          login_enter_your_password: '輸入您的密码',
          login_enter_a_valid_email: '輸入一个当前使用的邮箱账号',
          login_enter_a_valid_confirmation_code: '輸入一个确认密码',
          login_forgot_password: '忘記密码？',
          login_enter_verification_code_message:
            '請輸入您電子郵件中收到的驗證碼。',
          login_enter_confirmation_code_message:
            '請輸入您電子郵件中收到的確認碼。',
          login_enter_confirmation_code: '輸入确认密码',
          confirmation_code: '確認密码',
          login_new_password: '新密码',
          login_enter_a_valid_password: '輸入一个有效的密码',
          login_dont_have_account_message: '未开录账户？',
          login_sign_up: '登入',
          login_enter_first_name: '輸入您的名',
          login_enter_last_name: '輸入您的姓',
          login_enter_phone_number: '輸入您的电话号码',
          login_password_limitation_message:
            '密碼必須至少8個字元，且至少包含一個大寫字母和一個小寫字母。',
          account_first_name_invalid_data_message: '輸入有效的名',
          account_last_name_invalid_data_message: '輸入有效的姓',
          account_phone_number_invalid_data_message: '輸入有效的电话号码',
          account_email_invalid_data_message: '輸入有效的电子邮箱',
          account_notifications: '收到提醒信息？',
          loading: '在下载。。。',
          kc_developments: '生長',
          kc_auto_generate: '自動生成',
          kc_crop_type_invalid_data_message: '輸入作物种类',
          kc_variety: '品種',
          kc_variety_invalid_data_message: '輸入品種',
          kc_feature: '特徵',
          kc_feature_invalid_data_message: '輸入特徵',
          kc_sow_date: '播種日期',
          kc_sow_date_invalid_data_message: '輸入播種日期',
          kc_harvest_date: '收穫日期',
          kc_harvest_date_invalid_data_message: '輸入收穫日期',
          kc_kc_table: 'KC表格',
          kc_by_month: '按月计',
          kc_by_growth_phase: '按生长阶段计',
          kc_add_development_phase: '增加一个生长阶段',
          kc_phase_title_placeholder: '加入阶段名称',
          kc_first_phase_starts: '第一阶段开始日期',
          edit_field_choose_area_message: '需要為地块选择一个区域',
          edit_field_finish_open_edit_message:
            '更新地块前，请先完成或取消正在进行的编辑',
          edit_field_field_name: '地塊名称',
          edit_field_last_recommendation: '最後一次的建议',
          edit_field_no_fields: '沒有地塊可显示 😟',
          edit_field_field_name_invalid_data_message: '輸入有效的地塊名称',
          edit_field_area_invalid_data_message:
            '請使用左側繪圖工具標記您的田區範圍',
          edit_field_field_size_invalid_data_message: '輸入有效的地塊面积',
          edit: '编辑',
          edit_field_time_zone_invalid_message: '輸入时区',
          edit_field_water_meter_sensors: '流量計探头',
          edit_field_installation_date: '安装日期',
          edit_field_installation_date_invalid_message: '輸入安装日期',
          edit_field_contract_duration: '合同結束日期',
          edit_field_contract_duration_invalid_message: '合同期限必须大于今天',
          edit_field_delete_field_message: '確認需要删除该地块？',
          cluster: '集合',
          none_default: '沒有-默認',
          irrigate_command: '开始灌溉',
          get_ready_to_irrigate: '準備开始灌溉',
          dont_irrigate_command: '不需要灌溉',
          stress_level_very_high: '缺水状况非常严重',
          stress_level_high: '缺水状况严重',
          stress_level_getting_low: '缺水情況好轉',
          stress_level_optimal: '土壤濕潤状态最佳',
          stress_level_no_stress: '未发生缺水状况',
          no_recommendation_available: '沒有已提出的建議',
          no_recommendation: '沒有建議',
          expiration_date: '合同终止日期',
          soil_type: '土壤类型',
          crop_type: '作物类型',
          next_actions: '下一措施',
          take_the_app_to_the_field: '帶着N-Drip Connect 到田间',
          new: '� 上新！',
          history_graph: '历史曲线',
          download_the_app: '下载手机应用软件',
          coming_soon: '即將推出',
          dashboard_irrigation_amount: '灌溉水量',
          dashboard_my_fields: '我的地块',
          dashboard_delete_field: '刪除',
          dashboard_copy_field_id: '複製ID',
          dashboard_copy_field_description: '複製地塊描述',
          dashboard_copied: '已複製',
          dashboard_edit_field: '編輯',
          dashboard_add_field: '增加地块',
          dashboard_new_field: '新地块',
          dashboard_loading_data_message: '正在收集資料，預計需要6至8小時',
          no_planner_events: '目前为止没有计划实施的措施',
          management_distribution_units_management: '分佈单元管理',
          transmitter_admin_page: '傳感器测试',
          search_transmitter_title: '搜尋傳感器',
          search_transmitter_description:
            '輸入傳感器ID或選擇一個田塊來查看傳感器狀態和指標。',
          transmitter_not_found: '找不到傳感器或發生錯誤。',
          error_occurred: '發生錯誤',
          retry: '重試',
          detailed_data_unavailable: '部分詳細指標無法加載。',
          latest: '最新',
          management_admins_only: '仅限管理员',
          management_farming_units_management: '種植单元管理',
          management_delete_distribution_message: '確認删除该分佈？',
          management_manage_distribution_users_title: '管理（區域分佈）用户',
          management_enter_a_valid_username:
            '請輸入有效的使用者名稱 - 例如 user@domain.com',
          management_enter_a_valid_distribution_name: '輸入有效的地域分布名称',
          management_enter_a_valid_farming_unit_name: '輸入有效的種植單位名称',
          management_enter_a_valid_region: '輸入有效的地区',
          management_farming_unit_name: '種植单元名称',
          management_farming_unit_salesforce_id: '銷售人员ID',
          management_distribution_name: '地區分部名称',
          login_page: '登錄頁',
          time_zone: '時間區',
          tensiometers: '水壓計',
          support_planner: '支持計劃表',
          distribution_unit: '分佈單位',
          farming_unit: '種植單位',
          field_amount: '地塊數量',
          region: '區域',
          actions: '行動',
          close: '結束',
          user: '用戶',
          role: '角色',
          admin: '管理員',
          viewer: '觀察者',
          moderator: '調解者',
          account: '賬戶',
          preferences: '偏好設置',
          logout: '登出',
          first_name: '名',
          last_name: '姓',
          phone_number: '電話號碼',
          email: '郵箱',
          units: '單位',
          area: '面積',
          gdd: 'GDD',
          leaf_length: '叶子长度',
          leached: '滲濾量',
          plant: '植物',
          soil: '土壤',
          temperature: '溫度',
          weight: '重量',
          pressure: '壓力',
          length: '長度',
          volume: '體積',
          estimated_nitrogen_values: '估計的含氮量',
          temperature_celsius: '攝氏度',
          temperature_fahrenheit: '華氏度',
          weight_kg: '公斤',
          weight_lb: '磅',
          weight_tonne: '噸',
          weight_short_ton: '短噸',
          pressure_kpa: '千帕',
          pressure_psi: 'PSI',
          pressure_cbar: 'Bar',
          pressure_mm: '毫米',
          pressure_pa: 'Pa',
          length_mm: '毫米',
          length_inch: '英寸',
          volume_cubic_metre: '立方米',
          volume_gallon: '加侖',
          volume_bushel: '蒲式耳',
          volume_acre_foot: '英亩英尺',
          volume_acre_inch: '英亩英寸',
          volume_megaliter: '兆升',
          phase: '階段',
          kc: 'Kc',
          duration: '時長',
          days: '天',
          months_january: '一月',
          months_february: '二月',
          months_march: '三月',
          months_april: '四月',
          months_may: '五月',
          months_june: '六月',
          months_july: '七月',
          months_august: '八月',
          months_september: '九月',
          months_october: '十月',
          months_november: '十一月',
          months_december: '十二月',
          show_archived: '顯示存檔',
          choose_date: '選擇日期',
          last_day: '最後一天',
          last_week: '最後一周',
          last_two_weeks: '最後兩周',
          last_month: '最後一個月',
          last_six_months: '最后六个月',
          last_year: '去年',
          max: '最大',
          min: '最小',
          pressure_boundaries: '壓力範圍',
          max_date_range: '最大',
          activity_dates: '活動日期',
          supporting_data: '支撐數據',
          water_stress_level: '缺水状况',
          fertilization_gauge_title: '氮含量水平',
          map_view: '地图视角',
          serial_no: '序列号',
          sensor_serial_no: '探头系列号',
          sensor_latitude: '探头经度',
          sensor_longitude: '探头纬度',
          water_meter_units: '立方米数每個脈衝',
          name: '名稱',
          latitude: '經度',
          longitude: '緯度',
          create: '生成',
          update: '更新',
          field: '地塊',
          cancel: '取消',
          delete: '刪除',
          ok: 'OK',
          confirmation: '確認',
          confirm: '確認',
          yes: '是',
          no: '否',
          home: '主頁',
          change: '更改',
          forgot: '忘記',
          password: '密碼',
          login: '登錄頁',
          prefix: '前綴',
          register: '注冊',
          settings: '設置',
          based_on: '基於',
          amount: '數量',
          date_and_time: '日期和时间',
          report: '報告',
          hours: '小時數',
          report_irrigation: '報告灌溉量',
          report_nitrogen: '報告施肥量',
          is_manure: '用的是粪肥？',
          irrigation: '灌溉',
          select_sensors: '選择探头',
          select_all: '選擇所有',
          manure: '糞肥',
          nitrogen: '氨',
          fertilization_history: '施肥历史',
          water_pressure_history: '作物根系水势历史数据',
          designed_pressure: '設計水壓',
          support_ndvi: '支持NDVI?',
          n_in_organic_matter: '有机质中的氮含量',
          initial_concentrations: '開始含量',
          should_automate_irrigation: '自动灌溉',
          location: '地點',
          i_agree_to: '同意',
          terms_and_conditions: '條款和条件',
          language: '語言',
          last_update: '最後一次更新：',
          hours_ago: '{0}小時前',
          height: '高度',
          metric_india: '公制（印度）',
          metric_israel: '公制（以色列）',
          metric_australia: '公制（澳大利亞）',
          metric: '公制',
          imperial: '美製',
          unit_system: '單位系統',
          recommendations_unit: '建議單位',
          edit_field_pre_season_irrigation_start_date: '季前灌溉開始日期',
          meteorological_data: '氣象數據',
          station: '氣象站',
          distance: '距離',
          no_custom_station_added: '未添加自定義氣象站',
          select_station: '選擇氣象站',
          select_station_type: '選擇氣象站類型',
          no_stations_found: '找不到氣象站',
          find_nearest_station: '尋找最近的氣象站',
          add_station: '新增',
          drag_to_reorder_station: '拖曳以調整順序',
          station_priority_hint:
            '拖曳以設定優先順序。資料取自最上方的氣象站；它未提供的參數由下一個氣象站補上。',
          nearest_station_found:
            '最近的運作中氣象站：{{station}}（距田地 {{km}} 公里）',
          no_station_nearby: '{{km}} 公里內沒有已知位置的運作中氣象站',
          remove_station: '移除氣象站',
          et0: 'ETo',
          kc_optimized: '優化的Kc',
          hour: '小時',
          minute: '分鐘',
          minutes: '分鐘',
          irrigation_reported_successfully: '灌溉報告成功',
          fertilization_reported_successfully: '成功報告施肥過程',
          rain_reported_successfully: '降雨報告成功',
          wtr_reported_successfully: '水處理報告成功',
          hour_ago: '{0}小時前',
          day_ago: '{0}天前',
          days_ago: '{0}天前',
          days_ago_suffix: '天前',
          week_ago: '{0}周前',
          weeks_ago: '{0}周前',
          minute_ago: '{0}分鐘前',
          minutes_ago: '{0}分鐘前',
          ago: '前',
          today: '今天',
          yesterday: '昨天',
          enter_transmitter_id: '輸入傳輸器ID',
          transmitter_id: '傳輸器ID',
          transmitter_data_missing: '傳輸器數據缺失',
          sim_activation: '芯片正在啟動，請稍等10分鐘再進行下一次測試',
          last_seen: '最後一次显示：',
          recent_analog_values: '最近的模擬數據',
          recent_connectivity_values: '最近的連接性數據',
          recent_battery_values: '最近的電池數據',
          recent_c1_values: '最近的C1數據',
          recent_errors_values: '最近的錯誤數據',
          installation_date: '安裝日期',
          modem_version: '調制解調器版本',
          modem_hardware: '調制解調器硬件',
          iccid: 'ICCID',
          sensor_batch: '探頭批次號',
          transmission_interval: '信號傳輸間隔',
          sample_interval: '取樣間隔',
          micro_version: '微觀版本',
          sim_last_event: '最後一次SIM卡活動',
          date: '日期',
          value: '數據',
          test: '測試',
          Sand: '沙土',
          Loam: '壤土',
          Silt: '砂',
          Clay: '黏土',
          water_potential_graph: '水勢曲線',
          Cabbage: '捲心菜',
          Carrot: '胡蘿蔔',
          Cauliflower: '菜花',
          Celery: '芹菜',
          Lettuce: '生菜',
          Onion: '洋蔥',
          Spinach: '菠菜',
          Radish: '蘿蔔',
          Eggplant: '茄子',
          Tomato: '西紅柿',
          Cantaloupe: '密瓜',
          Cucumber: '黃瓜',
          Squash: '南瓜',
          Zucchini: '西葫蘆',
          Beet: '甜菜',
          Cassava: '木薯',
          Potato: '土豆',
          Bean: '豆角',
          Cowpea: '豇豆',
          Lentil: '扁豆',
          Pea: '青豆',
          Soybean: '黃豆',
          Artichoke: '朝鮮薊',
          Asparagus: '蘆筍',
          Cotton: '棉花',
          Flax: '亞麻籽',
          Safflower: '紅花',
          Sesame: '芝麻',
          Sunflower: '向日葵',
          Barley: '大麥',
          Oat: '燕麥',
          Wheat: '小麥',
          Maize: '玉米',
          Millet: '小米',
          Sorghum: '高粱',
          Rice: '水稻',
          Alfalfa: '苜蓿',
          Bermuda: '百慕大',
          Sudan: '蘇丹',
          Sugarcane: '甘蔗',
          Banana: '香蕉',
          Pineapple: '菠蘿',
          Grape: '葡萄',
          Hop: '啤酒花',
          Citrus: '柑橘',
          Olive: '橄欖',
          Pistachio: '開心果',
          Walnut: '核桃',
          Mango: '芒果',
          Grapefruit: '柚子',
          Garden: '花園',
          Grass: '草地',
          Avocado: '牛油果',
          Coffee: '咖啡',
          Corn: '玉米',
          Lychee: '荔枝',
          Watermelon: '西瓜',
          Pomegranate: '石榴',
          Cannabis: '大麻',
          Pepper: '胡椒',
          Blackberry: '黑莓',
          Strawberry: '草莓',
          Pecan: '胡桃',
          start: '開始',
          end: '結束',
          discharge: '排放水量',
          day_sunday: '星期日',
          day_monday: '星期一',
          day_tuesday: '星期二',
          day_wednesday: '星期三',
          day_thursday: '星期四',
          day_friday: '星期五',
          day_saturday: '星期六',
          planning: '計劃',
          field_view: '地塊視角',
          farm_view: '農場視角',
          new_section: '新功能！\n快速呈現您的農莊及灌溉狀況全貌',
          weekly_performance: '周活動',
          weekly_performance_tooltip: '呈現實際的灌溉狀況與計劃的對比',
          irrigation_activity_tooltip:
            '顯示最近一次灌溉結束的時間，或指示目前正在進行的灌溉',
          root_zone_water_potential_tooltip:
            '顯示該田區代表性感測器最近七天的根區水勢量測數據。',
          crop_water_availability: '作物水分\n可用性',
          water_availability_high: '高',
          water_availability_medium: '中',
          water_availability_low: '低',
          water_availability_no_data: '沒有數據',
          ndvi_layer: 'NDVI圖層',
          farm_map: '農場地圖',
          field_details: '地塊詳情',
          select_a_field_to_view_details: '選擇地塊以查看水勢圖',
          select_a_field_to_view_its_details: '選擇地塊以查看其詳情',
          date_chip_1d: '1天',
          date_chip_1w: '1週',
          date_chip_2w: '2週',
          date_chip_1m: '1月',
          date_chip_6m: '6月',
          date_chip_1y: '1年',
          graphs: '圖表',
          map: '地圖',
          previous: '上一個',
          next: '下一個',
          field_name: '地塊名稱',
          sort: '排序',
          advanced: '高級',
          advanced_mode: '高級模式',
          unknown_field: '未知地塊',
          not_available: '不可用',
          irrigating: '灌溉中',
          no_data: '沒有數據',
          plan: '計劃',
          since_date: '自 {{date}}',
          flow_meter_source: '流量計',
          manual_input_source: '手動輸入',
          connect_sensor_source: '連接傳感器',
          no_fields_available: '沒有可用的地塊',
          fields: '地塊',
          recommendation: '建議',
          stress_level: '缺水等級',
          root_zone_wp: '根區水勢',
          map_satellite: '衛星',
          map_topography: '地形',
          map_streets: '街道',
          ndvi_timeline: 'NDVI 時間線',
          planning_days: '天',
          planning_weeks: '星期',
          planning_publish: '公布',
          planning_planned: '計劃的',
          planning_used: '實際讀取數據',
          tomorrow: '明天',
          later: '稍後',
          event: '發生事件',
          events: '事件',
          fertilization: '施肥',
          hcl: '鹽酸',
          hpo: '次氯酸鈉',
          note: '備注',
          planning_note_placeholder: '請留言',
          sensors: '探頭',
          valves: '閥門',
          type: '類型',
          notify: '通知',
          irrigation_system: '灌溉系統',
          irrigation_type: '灌溉類型',
          irrigation_rate: '灌溉量',
          irrigation_time_frames: '灌溉時間範圍',
          define_time_frames: '設置可選擇的灌溉時間範圍',
          start_day: '開始日期',
          start_hour: '開始小時',
          end_hour: '結束小時',
          time_frame_conflict: '選擇的灌溉時間範圍與現有的灌溉時間範圍衝突',
          select_different_hour: '請選擇不同的小時',
          select_different_day: '請選擇不同的天',
          no_time_frames: '沒有灌溉時間範圍限制',
          for_this_field: '目前本地塊',
          locate_coordinates: '當地坐標',
          ignore_sensor_during_calculations: '計算過程中忽略',
          ignore_sensor_during_calculations_and_hide: '計算過程中忽略並隱藏',
          consider_as_flow_meter: '視為水表',
          alerts: '預警',
          stop_data_collection: '停止數據採集',
          accumulated_water_input: '累計水量輸入',
          soil_temperature: '土壤溫度',
          soil_temperature_graph_title: '土壤溫度',
          precipitation: '降雨',
          water_potential: '水勢',
          irrigation_activity: '灌溉計劃',
          root_zone_water_potential: '作物根部水勢',
          petiole: '葉柄',
          minimum: '最小',
          maximum: '最大',
          max_bigger_than_min: '最大值必須大於最小值',
          min_smaller_than_max: '最小值必須小於最大值',
          updated: '更新的',
          last_synced: '上次同步：',
          not_yet_set: '仍未設置',
          missing_values: '缺少數據',
          start_date: '開始日期',
          end_date: '結束日期',
          fertigation_concentrations: '施肥濃度',
          no_fertigation_concentrations_message: '沒有施肥濃度',
          days_from_sowing: '從播種日開始的天數',
          Field_details_days_in_season: '種植季內天數',
          field_size: '地塊面積',
          sensor_type: '探頭類型',
          sensor_sub_type: '探頭子類型',
          duplicate_field: '複製地塊',
          duplicate: '複製',
          dashboard_move_to_archive: '存入檔案',
          dashboard_unarchive: '取消存檔',
          alphabetic: '按字母順序',
          sort_by: '分類',
          sort_alphabetic: '按字母順序',
          sort_crop_availability: '作物水分可用性',
          sort_last_irrigation_new_old: '最後灌溉 (新 → 舊)',
          sort_last_irrigation_old_new: '最後灌溉 (舊 → 新)',
          sort_last_irrigation_duration_short_long: '最後灌溉 (最短 → 最長)',
          sort_last_irrigation_duration_long_short: '最後灌溉 (最長 → 最短)',
          sort_weekly_performance_high_low: '每週表現 (高 → 低)',
          sort_weekly_performance_low_high: '每週表現 (低 → 高)',
          Almond: '杏仁',
          Apple: '蘋果',
          Arugula: '芝麻菜',
          Blueberry: '藍莓',
          Broccoli: '西蘭花',
          Fig: '無花果',
          Garlic: '大蒜',
          Guayule: '銀膠菊',
          Jojoba: '荷荷芭油',
          Kiwi: '奇異果',
          Loquat: '枇杷',
          Mandarin: '橙子',
          Moringa: '辣木',
          Nectarine: '油桃',
          Orange: '橘子',
          Peach: '桃子',
          Peony: '牡丹花',
          Raspberry: '覆盆子',
          Planner: '計劃表',
          Irrigated: '已灌溉的',
          search_by_field: '以地塊查詢',
          free_search: '自由搜索',
          transmitters: '傳感器',
          distribution: '分布',
          sensor: '探頭',
          global_search_placeholder: '搜尋分布、種植單位、地塊和探頭',
          global_search_empty_hint: '開始輸入以依名稱或 ID 搜尋',
          global_search_no_results: '沒有找到結果',
          global_search_more_results:
            '顯示 {{total}} 個結果中的前 {{shown}} 個',
          global_search_recent_fields: '最近瀏覽的地塊',
          global_search_hint_navigate: '導覽',
          global_search_hint_select: '選擇',
          week: '周',
          season: '種植季',
          reported: '已經報告',
          events_list: '事件清單',
          no_reported: '沒有報告的事件',
          transmitter_name: '傳感器名稱',
          details: '細節',
          select_water_input: '選擇水量',
          etc: 'ETc',
          next_day: '第二天',
          crop_management: '作物管理',
          add_new_crop: '添加新作物',
          edit_parameters: '編輯參數',
          select_or_enter_crop_type: '選擇或輸入作物類型',
          select_or_enter_variety: '選擇或輸入品種',
          enter_sub_variety: '輸入子品種（可選）',
          select_or_enter_feature: '選擇或輸入特徵',
          add_new_button: '增加新選項',
          select_crop: '選擇作物...',
          phenological_phases: '物候階段',
          gdd_parameters: 'GDD參數',
          yield_parameters: '產量參數',
          fields_using_crop: '使用此作物的地塊',
          permission_hint: '僅顯示您有權查看的地塊',
          no_fields_found: '未找到使用此作物配置的地塊',
          select_crop_hint: '選擇作物類型以查看和編輯參數',
          loading_crop_data: '正在加載作物數據...',
          add_phase: '添加階段',
          duration_days: '時長（天）',
          duration_gdd: '時長（GDD）',
          is_development: '是否為發育期',
          stress_active: '缺水激活',
          stress_factor: '缺水係數',
          inherited: '繼承的',
          crop_updated_successfully: '作物更新成功',
          crop_update_failed: '作物更新失敗',
          crop_added_successfully: '作物添加成功',
          crop_add_failed: '作物添加失敗',
          crop_key_already_exists: '此作物鍵已存在',
          number_of_fields: '地塊數量',
          total_area: '總面積',
          total_water_usage: '總用水量',
          total_fertilizers_usage: '總化肥用量',
          total_nitrogen_leached: '總氮流失量',
          crop_types: '作物種類',
          report_event: '報告事件的發生',
          save: '保存',
          measurement: '計量',
          rain: '降雨',
          starting_time: '開始時間',
          create_planner_item: '增加新的計劃項',
          update_planner_item: '更新計劃項',
          containing: '包含',
          no_cluster: '沒有地塊集合',
          offset: '偏移',
          notes: '備注',
          week_total: '周總計',
          season_total: '季度總計',
          selected_field_only: '僅限選擇的地塊',
          farming_type: '種植類型',
          plant_height: '作物高度',
          fert_tank_height: '化肥罐液位',
          Fert_tank_volume: '化肥罐體積',
          fert_tank: '化肥罐',
          calibration_data: '校準數據',
          recommendations_tooltip: '建議可以幫助優化產量並改進決策過程的',
          allow_notifications: '允許通知',
          notifications_channels: '您被告知相關信息的渠道',
          event_type: '事件類型',
          login_enter_your_email_forgot_password:
            '請輸入您的電子郵件，我們將發送重設密碼的驗證碼給您：',
          push: '通告信息',
          recommendations: '建議',
          field_notifications: '您將接受每個地塊的哪些通知',
          none: '沒有',
          notifications: '通知',
          notifications_phase: '選擇各個地塊接受通知的類型和通道',
          alerts_tooltip: '嚴重事件發生的預警，用以保護您的作物',
          all_fields: '所有地塊',
          current_field: '目前地塊',
          alerts_message_continuous_irrigation_notification_center_title:
            '持續灌溉警報 - 位於 fieldX',
          alerts_message_continuous_irrigation_notification_center_body:
            '我們偵測到田區已連續灌溉超過2天。為保護您的作物和資源，我們強烈建議檢查田區是否有過度灌溉的情形。',
          low_pressure_event_hint: '此次灌溉偵測到低壓',
          high_pressure_event_hint: '此次灌溉偵測到高壓',
          low_pressure_detected_value: '偵測到低壓：{{value}}',
          high_pressure_detected_value: '偵測到高壓：{{value}}',
          alerts_message_low_pressure_notification_center_title:
            'fieldX 偵測到低壓',
          alerts_message_low_pressure_notification_center_body:
            'fieldX 量測到的壓力低於此感測器設定的最小值，可能減少供水量並影響田區的配水均勻度。建議檢查過濾器、閥門與管路。',
          alerts_message_high_pressure_notification_center_title:
            'fieldX 偵測到高壓',
          alerts_message_high_pressure_notification_center_body:
            'fieldX 量測到的壓力高於此感測器設定的最大值，可能對灌溉系統造成負擔並影響配水。建議檢查壓力調節裝置與下游閥門。',
          alerts_message_sensor_extreme_dry_conditions_notification_center_title:
            '田區偵測到極度乾燥狀況 - 資料來自 sensorX',
          alerts_message_sensor_extreme_dry_conditions_notification_center_body:
            'sensorX 的資料顯示田區狀況極度乾燥。為確保資料準確並保護您的作物，建議檢查灌溉計畫及感測器周圍的灌溉系統',
          alerts_message_long_dry_period_notification_center_title:
            '長時間未灌溉 - 建議對 fieldX 進行灌溉',
          alerts_message_long_dry_period_notification_center_body:
            'fieldX 已至少10天未接受灌溉，導致水分脅迫加劇。建議您依照 N-Drip 的建議對田區進行灌溉，以保護您的作物。',
          alerts_message_drying_trend_notification_center_title:
            '田區偵測到乾燥趨勢',
          alerts_message_wetting_trend_notification_center_title:
            '田區偵測到濕潤趨勢',
          alerts_message_drying_trend_notification_center_body:
            '我們發現 fieldX 的土壤水勢呈下降趨勢，已低於建議水準。為優化作物健康，請檢視您目前的灌溉方式，並依照 N-Drip 的建議進行調整。',
          alerts_message_wetting_trend_notification_center_body:
            '我們發現 fieldX 的土壤水勢呈上升趨勢，已高於建議水準。為優化作物健康，請檢視您目前的灌溉方式，並依照 N-Drip 的建議進行調整。',
          alerts_message_excessive_heat_notification_center_title: '空氣溫度高',
          alerts_message_excessive_heat_notification_center_body:
            '未來幾天 fieldX 預報將出現對您作物不利的高溫天氣。\n為保護您的作物，請查看並執行我們更新後的灌溉建議。',
          alerts_message_extreme_cold_notification_center_title: '低溫天氣',
          alerts_message_extreme_cold_notification_center_body:
            '未來幾天 fieldX 預報將出現對您作物不利的低溫天氣。\n為保護您的作物，請查看並執行我們更新後的灌溉建議。\n',
          alerts_message_dryland_long_dry_period_notification_center_title:
            '偵測到長時間乾旱期',
          alerts_message_dryland_long_dry_period_notification_center_body:
            'fieldX 已至少10天未接受水分，導致水分脅迫加劇。',
          alerts_message_dryland_sensor_exterme_dry_notification_center_title:
            '田區偵測到極度乾燥狀況 - 資料來自 sensorX',
          alerts_message_dryland_sensor_exterme_dry_notification_center_body:
            'sensorX 的資料顯示田區狀況極度乾燥',
          alerts_message_dryland_drying_trend_notification_center_title:
            '田區偵測到乾燥趨勢',
          alerts_message_dryland_drying_trend_notification_center_body:
            '我們發現 fieldX 的土壤水勢呈下降趨勢，導致水分脅迫加劇',
          alerts_message_low_tank_fert_notification_center_title:
            'fieldX 偵測到肥料液位偏低',
          alerts_message_low_tank_fert_notification_center_body:
            '我們偵測到 fieldX 肥料桶的液位已達到桶體運作高度最低門檻的10%。請安排補充肥料以確保作物持續施肥。',
          alerts_message_dryland_wetting_trend_notification_center_title:
            '田區偵測到濕潤趨勢',
          alerts_message_dryland_wetting_trend_notification_center_body:
            '我們發現 fieldX 的土壤水勢呈上升趨勢',
          alerts_message_dryland_excessive_heat_notification_center_title:
            '熱浪警報',
          alerts_message_dryland_excessive_heat_notification_center_body:
            '未來幾天 fieldX 區域預報將出現顯著熱浪',
          alerts_message_dryland_extreme_cold_notification_center_title:
            '寒流警報',
          alerts_message_dryland_extreme_cold_notification_center_body:
            '未來幾天 fieldX 區域預報將出現顯著寒流。',
          alerts_message_dryland_ndvi_notification_center_title: '植被活性下降',
          alerts_message_dryland_ndvi_notification_center_body:
            '我們近期對 NDVI 影像歷史的分析顯示，fieldX 的植被生長出現明顯下降。為優化作物健康，請檢視您目前的灌溉方式。',
          no_notifications: '目前沒有通知',
          load_more: '加載更多',
          notifications_welcome_message_title: '歡迎來到新的通知界面',
          notifications_welcome_message_body:
            '透過桌面和行動裝置，隨時掌握您田區中當前及預期的重要事件',
          planner_days_shorts_sun: '周日',
          planner_days_shorts_mon: '周一',
          planner_days_shorts_tue: '周二',
          planner_days_shorts_wed: '周三',
          planner_days_shorts_thu: '周四',
          planner_days_shorts_fri: '周五',
          planner_days_shorts_sat: '周六',
          shorts_months_january: '一月',
          shorts_months_february: '二月',
          shorts_months_march: '三月',
          shorts_months_april: '四月',
          shorts_months_may: '五月',
          shorts_months_june: '六月',
          shorts_months_july: '七月',
          shorts_months_august: '八月',
          shorts_months_september: '九月',
          shorts_months_october: '十月',
          shorts_months_november: '十一月',
          shorts_months_december: '十二月',
          dont_show_again: '不要重複顯示',
          notifications_settings: '通知設置',
          read_more: '閱讀更多',
          show_less: '顯示更少',
          distribution_menu_select: '選擇分佈區域',
          farming_unit_menu_select: '選擇種植單位',
          field_menu_select: '選擇地塊',
          recent_field: '近期查看過的地塊',
          discharge_test: '流量排放測試',
          planner_season_start: '季度開始',
          planner_season_end: '季度結束',
          planner_growth_phase_initial: '開始',
          planner_growth_phase_development: '進展',
          planner_growth_phase_middle: '中期',
          planner_growth_phase_late: '晚期',
          planner_add_event_button: '添加事件',
          planner_water_treatment: '水處理',
          planner_add_button: '增加',
          planner_start_time: '開始時間',
          country: '國家',
          monday_id: 'Monday ID',
          delete_item_title: '本項將被刪除',
          delete_item_text: '本操作無法恢復，數據將丟失',
          average: '平均',
          seconds: '秒',
          event_delete_successfully: '事件已成功刪除',
          reported_successfully: '測試已成功完成報告',
          report_unsuccessfully: '該事件目前無法報告，請稍後再試',
          event_delete_unsuccessfully: '該事件目前無法被刪除，請稍後再試',
          Insights_title_county: '縣',
          Insights_group_by: '分組類型',
          edit_field_measured_irrigation_rate: '測量的灌溉量',
          edit_field_representative_input_checkbox:
            '量測灌溉速率可用時自動採用。此設定將影響規劃器',
          edit_field_tank_type: '水箱類型',
          edit_field_recommendation_display: '灌溉資料顯示方式',
          recommendation_display_duration: '時長',
          recommendation_display_amount: '水量',
          edit_field_recommendation_display_description:
            '時長為 N-Drip、Seepage、Flood 與 Furrow 系統的預設值，其餘系統預設為水量。變更灌溉類型時，此設定會重設為該系統的預設值。',
          timeframe_name: '時間範圍',
          wtr_checkbox: '包括水處理',
          kc_phases_stress_checkbox: '減少灌溉量',
          kc_phases_stress_tooltip:
            '依照以下 ETc 減少百分比，開始計畫性作物水分脅迫期',
          edit_field_irrigation_timeframe_source_soil: '土壤類型限制',
          edit_field_irrigation_timeframe_tooltip: '原始限制條件：',
          edit_field_irrigation_timeframe_source_irrigation_rate: '灌溉量',
          edit_field_irrigation_timeframe_source_user: '由用戶定義',
          source: '來源',
          discharge_result_exceeding_hint: '測試結果與排放趨勢不符',
          Timeframe_no_end_date: '直到另行通知',
          Farming_unit_entity_basic_info: '基本信息',
          WT_protocol_edit_field_water_properties_section_title: '水質',
          WT_protocol_edit_field_water_source: '水源',
          WT_protocol_edit_field_water_conveyance: '露天還是封閉',
          WT_protocol_edit_field_water_analysis_section_title: '水質分析',
          WT_protocol_edit_field_water_analysis_section_subtitle:
            '請參閱各欄位中的建議範圍',
          WT_protocol_edit_field_water_analysis_table_materials: '水中所含物質',
          WT_protocol_edit_field_water_analysis_table_score: '數值',
          WT_protocol_edit_field_water_analysis_table_low: '低',
          WT_protocol_edit_field_water_analysis_table_medium: '中',
          WT_protocol_edit_field_water_analysis_table_high: '高',
          WT_protocol_edit_field_water_analysis_table_organic: '有機物',
          WT_protocol_edit_field_water_analysis_table_calc: '鈣',
          WT_protocol_edit_field_water_analysis_table_fe: '鐵',
          WT_protocol_edit_field_material_concentrations: '液體濃度',
          WT_protocol_edit_field_acid_titration: '酸滴定',
          WT_protocol_edit_field_HPO_concentrations: 'HPO 濃度',
          Farming_unit_entity_tooltip: '取消的項目可以通過編輯種植單位而改變',
          WT_timing_recommendation_after_irrigation_starts: '灌溉30分鐘後',
          WT_timing_recommendation_last_hour: '灌溉最後一個小時',
          Fert_sensor_fertlization_type: '施肥種類',
          fertilizer_meter_id: '肥料計量表ID',
          add_fertilizer: '施加化肥',
          Farming_unit_entity_all: '所有',
          basic_info: '基本信息',
          KC_phases_title: '當前生長階段',
          KC_phases_title_pre_season: '季度前',
          KC_phases_title_in_between_seasons: '季度間',
          KC_phases_phase_tooltip_start: '開始',
          KC_phases_phase_tooltip_end: '結束',
          KC_phases_button_save: '保存',
          KC_phases_button_reset: '重新設置',
          KC_phases_stress_inidication: '受控的降低水量的灌溉',
          KC_phases_button_edit: '編輯',
          KC_phases_fast_flow: '設置當前階段',
          KC_phases_now_indication: '現在',
          KC_phases_estimated_short: '估計值',
          KC_phases_season_ended: '種植季結束',
          KC_phases_season_end: '季度終止於',
          KC_phases_estimated_season_end: '估計的季度結束日期',
          KC_phases_edit_mode_default_title: '選擇一個時間段調整其時長',
          installation_depth: '深度',
          kc_phases_error_message: '輸入的數據與現有的時間相關的輸入衝突',
          edit_field_timeframe_constraint_first_day: '本周第一天',
          edit_field_planner_type_no_planner: '無計劃表',
          edit_field_planner_type_by_day: '逐日灌溉計劃',
          edit_field_planner_type_by_week: '每周灌溉計劃',
          edit_field_planner_no_irrigation: '沒有灌溉',
          edit_field_timeframe_constraint_season_target: '種植季灌溉目標',
          edit_field_timeframe_constraint_interval_mode:
            '間隔模式（設定兩次灌溉之間的天數間隔）',
          edit_field_timeframe_constraint_weekly_mode: '每周（每周最多X次）',
          edit_field_timeframe_no_frequnecy_constraint:
            '若未定義時段，規劃器將每天執行',
          add_time_frames: '添加時間範圍限制以在此處查看',
          gauge_title_v3: '作物水分可用性',
          gauge_high_v3: '高',
          gauge_medium_v3: '中',
          day: '天',
          edit_field_planner_changes_message_first_day_body:
            '變更每週起始日將影響建議結果',
          edit_field_planner_changes_message_mode_body:
            '變更灌溉模式將影響建議結果',
          select_graphs: '選擇曲線',
          accumulated_graph_baseline_recommendation_more_info_description:
            '基於作物模型的ETc（Kc × ETo），已根據您的灌溉系統效率進行調整。',
          accumulated_graph_adaptive_recommendation_more_info_description:
            '基於優化Kc的ETc，已根據您的灌溉系統效率進行調整。',
          accumulated_graph_title_baseline_recommendation: '基準線建議',
          accumulated_graph_title_adaptive_recommendation: '調整後的建議',
          field_list_title_: '地塊列表',
          soil_temperature_values: '土壤溫度日均值、最高值、最近時段',
          assumption: '假設',
          issue: '問題',
          extract_sensor: '取出探頭',
          select_assumption: '選擇假設',
          select_sensor: '選擇探頭',
          comment: '評論',
          reporting: '報告中...',
          air_burst: '氣爆',
          bad_values: '異常數據',
          no_transmission: '無信號傳輸',
          low_pressure_detected: '監測到低壓',
          high_pressure_detected: '監測到高壓',
          long_dry_period: '長時間乾旱',
          drying_trend: '乾燥趨勢',
          wetting_trend: '濕潤趨勢',
          sensor_not_responding_to_irrigation: '探頭對灌溉無響應',
          missed_irrigation: '錯過灌溉',
          continuous_irrigation: '連續灌溉',
          select_placeholder: '選擇...',
          report_issue: '報告出現的問題',
          report_issue_for: '報告有關的問題',
          report_issue_title:
            '請從列表中選擇相關問題。田區的附加資訊將自動傳送。',
          report_issue_placeholder: '還有什麼可以澄清該問題？',
          report_issue_error: '報告過程中發生問題。請稍後再試。',
          report_issue_success_message: '報告成功完成',
          report_issue_view_on_monday: '在Monday上查看',
          report_issue_sensor_issues: '傳感器問題',
          report_issue_field_issues: '地塊問題',
          delete_my_data: '刪除我的數據',
          delete_data_warning_grace:
            '此操作將排程永久刪除您在系統中的所有資料。您將有 {{days}} 天的時間可以取消此請求，之後資料將被永久刪除。',
          delete_data_confirm: '您確定要刪除所有數據嗎？',
          delete_data_success_grace:
            '您的資料刪除請求已提交。您的資料將在 {{days}} 天後被永久移除。',
          delete_data_confirmation_email:
            '確認信已發送至您的電子郵件地址。您可以在寬限期內聯繫客服取消此請求。',
          delete_data_button: '刪除所有數據',
          delete_data_confirm_button: '是的，刪除我的數據',
          delete_data_error: '刪除數據時發生錯誤，請稍後再試。',
          delete_data_enter_password: '輸入密碼以確認',
          delete_data_password_required: '需要輸入密碼才能繼續',
          delete_data_reason_label: '您為什麼要刪除數據？（可選）',
          delete_data_reason_select: '選擇原因...',
          delete_data_reason_no_longer_need: '我不再需要此服務',
          delete_data_reason_privacy_concerns: '隱私問題',
          delete_data_reason_switching_service: '切換到其他服務',
          delete_data_reason_too_complex: '服務太複雜',
          delete_data_reason_other: '其他',
          high_pressure: '高壓',
        },
      },
      es: {
        translations: {
          new_planner_title: 'Recomendación de riego',
          no_irrigation_planning_this_week:
            'No se necesita riego en este momento',
          new_planner_no_recommendation_available_indication:
            'Recomendación de riego no disponible: faltan datos.',
          new_planner_recommendation_irrigate: 'Regar',
          new_planner_recommendation_amount: 'Cantidad',
          new_planner_recommendation_frequency: 'Frecuencia',
          new_planner_recommendation_times_a_week: 'Veces por semana',
          new_planner_recommendation_every: 'A cada',
          new_planner_recommendation_days: 'Días',
          new_planner_recommendation_format_every_day: 'todos los días',
          day: 'día',
          new_planner_recommendation_daily_return: 'Diario',
          new_planner_recommendation_daily_return_avg: 'Promedia',
          new_planner_this_week: 'Esta semana',
          new_planner_next_week: 'Próxima semana',
          new_planner_previous_week: 'Semana passada',
          new_planner_previuos_week: 'Semana anterior',
          new_planner_feedback: '¿Le resultó útil esta recomendación?',
          new_planner_rain_excluded:
            'Se excluyen los pronósticos de lluvia para garantizar una planificación fiable.',
          new_planner_feedback_thanks:
            'Gracias por compartir esta información.',
          gauge_low_v2: 'Bajo',
          gauge_good_v2: 'Bién',
          gauge_critcal_v2: 'Crítico',
          gauge_no_data_v2: 'Sin datos',
          gauge_title_v2: 'Estado hídrico del cultivo',
          gauge_title_v3: 'Disponibilidad de agua para las plantas',
          gauge_high_v3: 'Alto',
          gauge_medium_v3: 'Medio',
          gauge_low_v3: 'Bajo',
          done_button: 'Terminado',
          timeframe_name: 'Identificación del periodo',
          insights_tab: 'Análisis',
          field_view: 'Vista del Campo',
          farm_view: 'Vista de Finca',
          new_section:
            '¡Nuevo!\nVea toda la información de su granja y riego de un vistazo',
          edit_field_planner_type_by_week: 'Recomendación semanal',
          weekly_performance: 'Rendimiento semanal',
          weekly_performance_tooltip:
            'Muestra los eventos de riego actuales en comparación con el programa recomendado',
          irrigation_activity_tooltip:
            'Muestra cuándo finalizó el último riego o indica un riego activo',
          root_zone_water_potential_tooltip:
            'Muestra mediciones del potencial hídrico de la zona radicular, obtenidas por el sensor de campo representativo, durante los últimos siete días disponibles',
          edit_field_pre_season_irrigation_start_date:
            'Fecha de inicio del riego pre-temporada',
          login_registration_confirmation_message:
            'Por favor, confirme su registro haciendo clic en el enlace de confirmación recibido por correo eletronico en tu cuenta',
          login_registration_after_confirmation_message:
            'Después de la confirmación, vaya a',
          login_registration_after_confirmation_message_2: 'e iniciar sesión',
          login_enter_your_email: 'Ingrese tu correo eletrónico',
          support_leave_message: 'Déjanos un mensaje',
          support_name_label: 'Tu nombre',
          support_email_label: 'Dirección de correo electrónico',
          support_optional: 'opcional',
          support_required: 'obligatorio',
          support_name_placeholder: 'Ingrese su nombre',
          support_help_message_title: '¿Cómo podemos ayudarte?',
          support_attachments: 'Adjuntos',
          support_add_files: 'Agrega hasta {{count}} archivos',
          support_drop_files: 'Suelta los archivos aquí',
          support_remove_attachment: 'Eliminar adjunto',
          support_minimize_widget: 'Minimizar widget',
          support_message_sent: 'Mensaje enviado con éxito',
          support_message_failed: 'Algo salió mal',
          support_sending: 'Enviando...',
          support_login_required:
            'Debes iniciar sesión para enviar un mensaje de soporte.',
          login_enter_your_password: 'Ingrese tu contraseña',
          login_enter_a_valid_email:
            'Ingrese una cuenta de correo eletrónico válida',
          login_enter_a_valid_confirmation_code:
            'Ingrese un código de confimación válido',
          login_forgot_password: '¿Se te olvidó tu contraseña?',
          login_enter_verification_code_message:
            'Ingrese el código de verificación que recibió en su cuenta de correo eletrónico',
          login_enter_confirmation_code_message:
            'Ingrese el código de confirmación que recibió en su cuenta de correo eletrónico',
          login_enter_confirmation_code: 'Ingrese el código de confirmación',
          confirmation_code: 'Código de confirmación',
          login_new_password: 'Nueva contraseña',
          login_enter_a_valid_password: 'Ingrese una contraseña válida',
          login_dont_have_account_message: '¿No tienes cuenta?',
          login_sign_up: 'Regístrate',
          login_enter_first_name: 'Ingrese tu primer nombre',
          login_enter_last_name: 'Ingrese tu apellido',
          login_enter_phone_number: 'Ingrese tu número telefónico',
          login_password_limitation_message:
            'La contraseña debe tener al menos 8 caracteres con al menos una letra mayúscula y minúscula.',
          account_first_name_invalid_data_message:
            'Ingrese un primer nombre válido',
          account_last_name_invalid_data_message: 'Ingrese un apellido válido',
          account_phone_number_invalid_data_message:
            'Ingrese un número telefónico válido',
          account_email_invalid_data_message:
            'Ingrese un correo eletrónico válido',
          account_notifications: '¿Quieres recibir notificaciones?',
          loading: 'Cargando...',
          kc_developments: 'Desarrollo',
          kc_auto_generate: 'Autogenerar',
          kc_crop_type_invalid_data_message:
            'Ingrese un tipo de cultura válido',
          kc_variety: 'Variedad',
          kc_variety_invalid_data_message: 'Ingrese una variedade válida',
          kc_feature: 'Característica',
          kc_feature_invalid_data_message: 'Ingrese una característica válida',
          kc_sow_date: 'Fecha de siembra',
          kc_sow_date_invalid_data_message:
            'Ingrese una fecha de siembra válida',
          kc_kc_table: 'Tabela de Kc',
          kc_by_month: 'Por mes',
          kc_by_growth_phase: 'Por fase de crecimiento',
          kc_add_development_phase: 'Agregar una fase de desarrollo',
          kc_phase_title_placeholder: 'Inserte el título de la fase',
          kc_first_phase_starts: 'La primera fase comienza el',
          edit_field_choose_area_message: 'Elige un área para su campo',
          edit_field_finish_open_edit_message:
            'Termina o cancela la edición abierta antes de actualizar el campo',
          edit_field_field_name: 'Nombre del campo',
          edit_field_last_recommendation: 'Última recomendación',
          edit_field_no_fields: 'No hay campos para mostrar',
          edit_field_field_name_invalid_data_message:
            'Ingrese un nombre de campo válido',
          edit_field_area_invalid_data_message:
            'Marque su área de campo usando el menú de dibujo a la izquierda',
          edit_field_field_size_invalid_data_message:
            'Ingrese un tamaño de campo válido',
          edit_field_time_zone_invalid_message:
            'Ingrese una zona horaria válida',
          edit_field_water_meter_sensors: 'Sensores de medición de agua',
          edit_field_installation_date: 'Fecha de instalación',
          edit_field_installation_date_invalid_message:
            'Ingrese una fecha de instalación válida',
          edit_field_contract_duration: 'Duración del contrato (años)',
          edit_field_contract_duration_invalid_message:
            'La duración del contrato debe ser mayor que 0',
          edit_field_delete_field_message:
            'Seguro que quieres eliminar el campo?',
          cluster: 'Cluster',
          meteorological_data: 'Datos Meteorológicos',
          station: 'Estación',
          distance: 'Distancia',
          no_custom_station_added:
            'No se ha añadido ninguna estación personalizada',
          select_station: 'Seleccionar estación',
          select_station_type: 'Seleccionar tipo de estación',
          no_stations_found: 'No se encontraron estaciones',
          find_nearest_station: 'Buscar estación más cercana',
          add_station: 'Agregar',
          drag_to_reorder_station: 'Arrastrar para reordenar',
          station_priority_hint:
            'Arrastre para definir la prioridad. Los datos vienen de la estación superior; los parámetros que no informa se toman de la siguiente.',
          nearest_station_found:
            'Estación activa más cercana: {{station}} (a {{km}} km del campo)',
          no_station_nearby:
            'No hay estaciones activas con ubicación conocida a menos de {{km}} km',
          remove_station: 'Eliminar estación',
          irrigate_command: 'Por favor, irrigue',
          get_ready_to_irrigate: 'Prepárate para irrigar',
          dont_irrigate_command: 'No es necesario irrigar',
          stress_level_very_high: 'El nivel de estrés es muy alto',
          stress_level_high: 'El nivel de estrés es alto',
          stress_level_getting_low: 'El nivel de estrés está bajando',
          stress_level_optimal: 'El nivel de estrés es óptimo',
          no_recommendation_available: 'No hay recomendación disponible',
          expiration_date: 'Fecha de expiración',
          soil_type: 'Tipo de suelo',
          crop_type: 'Tipo de cultivo',
          dashboard_irrigation_amount: 'Cantidad de irrigación',
          dashboard_my_fields: 'Mis Campos',
          dashboard_delete_field: 'Eliminar',
          dashboard_copy_field_id: 'Copiar el campo',
          dashboard_copy_field_description: 'Copiar descripción del campo',
          dashboard_copied: 'Copiado',
          dashboard_edit_field: 'Editar',
          dashboard_add_field: 'Agregar campo',
          dashboard_new_field: 'Nuevo campo',
          dashboard_loading_data_message:
            'Estamos recopilando datos, debe tomar entre 6 a 8 horas.',
          management_distribution_units_management:
            'Gestión de Unidades de Distribución',
          transmitter_admin_page: 'Evaluación de transmisores',
          search_transmitter_title: 'Buscar un Transmisor',
          search_transmitter_description:
            'Ingrese el ID del transmisor o seleccione un campo para ver el estado y las métricas del transmisor.',
          transmitter_not_found:
            'Transmisor no encontrado o se produjo un error.',
          error_occurred: 'Se produjo un error',
          retry: 'Intentar de Nuevo',
          detailed_data_unavailable:
            'Algunas métricas detalladas no se pudieron cargar.',
          latest: 'Más Reciente',
          management_admins_only: 'Solo administradores',
          management_farming_units_management: 'Manejo de Unidades Agrícolas',
          management_delete_distribution_message:
            '¿Estás seguro de que deseas eliminar la distribución?',
          management_manage_distribution_users_title:
            'Administrar (distribución) usuarios',
          management_enter_a_valid_username:
            'Ingrese un nombre de usuario válido - ej. usuario@dominio.com',
          management_enter_a_valid_distribution_name:
            'Ingrese un nombre de distribución válido',
          management_enter_a_valid_farming_unit_name:
            'Ingrese un nombre de unidade agrícola válido',
          management_enter_a_valid_region: 'Ingrese una región válida',
          management_farming_unit_name: 'Nombre de la unidade agrícola',
          management_farming_unit_salesforce_id: 'Salesforce ID',
          management_distribution_name: 'Nombre de distribución',
          time_zone: 'Zona horaria',
          tensiometers: 'Tensiómetros',
          distribution_unit: 'Unidad de distribución',
          farming_unit: 'Unidad agrícola',
          field_amount: 'Cantidad de campos',
          region: 'Región',
          actions: 'Acciones',
          close: 'Cerrar',
          user: 'Usuario',
          role: 'Papel',
          admin: 'Administrador',
          viewer: 'Espectador',
          account: 'Cuenta',
          preferences: 'Preferencias',
          logout: 'Cerrar sesión',
          first_name: 'Primer nombre',
          last_name: 'Apellido',
          phone_number: 'Número de teléfono',
          email: 'Correo eletrónico',
          units: 'Unidades',
          area: 'Zona',
          gdd: 'GDD',
          et0: 'ETo',
          leached: 'Lixiviado',
          plant: 'Planta',
          soil: 'Suelo',
          temperature: 'Temperatura',
          weight: 'Peso',
          pressure: 'Presión',
          length: 'Extensión',
          volume: 'Volumen',
          estimated_nitrogen_values: 'Valores estimados de nitrógeno',
          temperature_celsius: 'Celsius',
          temperature_fahrenheit: 'Fahrenheit',
          weight_kg: 'Kg',
          weight_lb: 'lb',
          weight_tonne: 'Tonelada',
          weight_short_ton: 'Tonelada corta',
          pressure_kpa: 'kPa',
          pressure_psi: 'PSI',
          pressure_cbar: 'CBar',
          pressure_mm: 'mm',
          pressure_pa: 'Pa',
          length_mm: 'mm',
          length_inch: 'Polegada',
          volume_cubic_metre: 'Metro cúbico',
          volume_gallon: 'Galón',
          volume_bushel: 'Bushel',
          volume_acre_foot: 'Pie por acre',
          volume_acre_inch: 'Pie por polegada',
          volume_megaliter: 'megalitro',
          phase: 'Fase',
          kc: 'Kc',
          kc_optimized: 'Kc optimizado',
          duration: 'Duración',
          days: 'Días',
          months_january: 'Janero',
          months_february: 'Febrero',
          months_march: 'Marzo',
          months_april: 'Abril',
          months_may: 'Mayo',
          months_june: 'Junio ',
          months_july: 'Julio',
          months_august: 'Agosto',
          months_september: 'Septiembre',
          months_october: 'Octubre',
          months_november: 'Noviembre',
          months_december: 'Diciembre',
          choose_date: 'Elegir fecha',
          last_day: 'Último día',
          last_week: 'Última semana',
          last_two_weeks: 'Últimas 2 semanas',
          last_month: 'Último mes',
          last_six_months: 'Últimos 6 meses',
          last_year: 'Último año',
          max: 'Máx',
          min: 'Mín',
          pressure_boundaries: 'Límites de Presión',
          max_date_range: 'Máx',
          supporting_data: 'Datos de soporte',
          water_stress_level: 'Nivel de estrés',
          fertilization_gauge_title: 'Niveles de nitrógeno',
          map_view: 'Vista del mapa',
          serial_no: 'Número de serie',
          sensor_serial_no: 'Número de serie del sensor',
          sensor_latitude: 'Latitud del sensor',
          sensor_longitude: 'Longitud del sensor',
          water_meter_units: 'm3 por pulso',
          name: 'Nombre',
          leaf_length: 'Longitud de las hojas',
          latitude: 'Latitud',
          longitude: 'Longitud',
          create: 'Crear',
          update: 'Actualizar',
          field: 'Campo',
          cancel: 'Cancelar',
          delete: 'Borrar',
          ok: 'OK',
          confirmation: 'Confirmación',
          confirm: 'Confirmar',
          yes: 'Si',
          no: 'No',
          home: 'Inicio',
          change: 'Cambiar',
          forgot: 'Olvidó',
          password: 'Contraseña',
          login: 'Iniciar sésion',
          prefix: 'Prefijo',
          register: 'Registro',
          settings: 'Configuraciones',
          amount: 'Cantidad',
          date_and_time: 'Fecha y hora',
          report: 'Insertar',
          hour: 'hora',
          hours: 'horas',
          minute: 'minuto',
          minutes: 'minutos',
          report_irrigation: 'Insertar irrigación',
          report_nitrogen: 'Insertar nitrógeno',
          irrigation_reported_successfully: 'Irrigación informada con éxito',
          is_manure: '¿Es estiercól?',
          irrigation: 'Irrigación',
          select_sensors: 'Seleccionar sensores',
          manure: 'Estiercól',
          nitrogen: 'Nitrógeno',
          fertilization_history: 'Historial de fertilización',
          water_pressure_history: 'Historia del potencial hídrico',
          transmitter_id: 'Identificación del transmisor',
          transmitter_data_missing: 'Datos del transmisor no disponibles',
          support_ndvi: '¿Soporte NDVI?',
          i_agree_to: 'Estoy de acuerdo con',
          terms_and_conditions: 'Términos y condiciones',
          language: 'Idioma ',
          last_update: 'Última actualización',
          hours_ago: 'hace {0} horas',
          hour_ago: '1 hora antes',
          day_ago: 'Hace 1 día',
          days_ago: 'Hace {0} días',
          days_ago_suffix: 'días atrás',
          week_ago: 'Hace {0} semana',
          weeks_ago: 'Hace {0} semanas',
          yesterday: 'ayer',
          minute_ago: 'Hace 1 minuto',
          minutes_ago: 'Hace {0} minutos',
          ago: 'atrás',
          login_page: 'Página de inicio',
          based_on: 'Basado en',
          test: 'Prueba',
          Sand: 'Arenoso',
          'Loamy Sand': 'Arenoso franco',
          'Sandy Loam': 'Franco arenoso',
          Loam: 'Franco',
          Silt: 'Limoso',
          'Silty Loam': 'Franco limoso',
          'Sandy Clay Loam': 'Franco arcillo arenoso',
          'Clay Loam': 'Franco arcilloso',
          'Silty Clay Loam': 'Franco arcillo limoso',
          'Sandy Clay': 'Arcillo arenoso',
          'Silty Clay': 'Arcillo limoso',
          Clay: 'Arcilloso',
          'Mix of Peat types': 'Turba',
          'Coconut fiber': 'Fibra de coco',
          'Mixed Tuff': 'Otros sustratos orgánicos',
          Artichoke: 'Alcachofa',
          Asparagus: 'Espárragos',
          Avocado: 'Palta',
          last_seen: 'Visto por última vez',
          recent_analog_values: 'Valores analógicos recientes',
          recent_battery_values: 'Valores recientes de la bateria',
          recent_c1_values: 'Valores C1 recientes',
          modem_version: 'Versión de lo modém ',
          modem_hardware: 'Hardware de lo modém ',
          iccid: 'ICCID',
          date: 'Fecha',
          value: 'Valor',
          sim_activation:
            'La SIM se está activando, espere 10 minutos antes de volver a probar',
          enter_transmitter_id: 'Ingrese da ID del transmisor',
          Cabbage: 'Repollo',
          Carrot: 'Zanahoria',
          Cauliflower: 'Coliflor',
          Celery: 'Apio',
          Lettuce: 'Lechuga',
          Onion: 'Cebolla',
          Spinach: 'Espinaca',
          Radish: 'Rábano',
          Eggplant: 'Berenjena',
          'Sweet pepper': 'Pimiento morrón',
          Tomato: 'Tomate',
          Cantaloupe: 'Melón',
          Cucumber: 'Pepino',
          'Pumpkin (Winter Squash)': 'Calabaza (Invierno)',
          Squash: 'Calabaza',
          Zucchini: 'Calabacín',
          'Sweet Melon': 'Melón dulce',
          Beet: 'Remolacha',
          Cassava: 'Mandioca',
          Potato: 'Papa',
          'Sweet potato': 'Papa dulce',
          'Sugar Beet': 'Remolacha azucarera',
          Bean: 'Frijol',
          'Faba bean, broad bean': 'Haba',
          'Green Gram': 'Garbanzo',
          Cowpea: 'Frijoles negros',
          'Peanut (Groundnut)': 'Maní',
          Lentil: 'Lenteja',
          Pea: 'Guisante',
          Soybean: 'Soja',
          Cotton: 'Algodón',
          Flax: 'Linaza',
          'Castorbean (Ricinus)': 'Castorbean (ricinus)',
          Safflower: 'Cártamo',
          Sesame: 'Sésamo',
          Sunflower: 'Girasol',
          Barley: 'Cebada',
          Oat: 'Avena',
          Wheat: 'Trigo',
          Maize: 'Maíz',
          Millet: 'Mijo',
          Sorghum: 'Sorgo',
          Rice: 'Arroz',
          Alfalfa: 'Alfafa',
          Bermuda: 'Grama Bermuda',
          Sudan: 'Hierba de Sudán',
          Sugarcane: 'Caña de azúcar',
          Banana: 'Banana',
          Pineapple: 'Piña',
          Grape: 'Uva',
          Hop: 'Lúpulo',
          Citrus: 'Citrus',
          Olive: 'Oliveira',
          Pistachio: 'Pistacho',
          Walnut: 'Nuez',
          'Cattails, Bulrush': 'Taboa',
          Mango: 'Mango',
          Grapefruit: 'Pomelo',
          Garden: 'Plantas de jardín',
          Grass: 'Gramo',
          'Genus Citrus': 'Cítricos (género)',
          Coffee: 'Café',
          Corn: 'Maíz',
          Lychee: 'Lychee',
          'Peach, Nectarine': 'Durazno, Nectarina',
          Watermelon: 'Sandía',
          'Date Palm': 'Dátil',
          Pomegranate: 'Granada',
          Cannabis: 'Cáñamo',
          Pepper: 'Pimienta',
          Blackberry: 'Mora',
          Strawberry: 'Fresa',
          Pecan: 'Nuez',
          soil_water_deficit: 'Déficit hídrico del suelo',
          n_in_organic_matter: 'N en materia orgánica',
          initial_concentrations: 'Concentraciones iniciales',
          should_automate_irrigation: 'Automatizar el riego',
          kc_harvest_date: 'Fecha de cosecha',
          kc_harvest_date_invalid_data_message:
            'Ingrese una fecha de cosecha válida',
          micro_version: 'Versión micro',
          notifications: 'Notificaciones',
          location: 'Localización',
          installation_date: 'Fecha de instalación',
          new: '¡Nuevo!',
          download_the_app: 'Descarga la aplicación móvil',
          take_the_app_to_the_field:
            'Tome N-Drip Connect mientras ingresa al campo',
          etc: 'ETc',
          distribution: 'Distribución',
          sensor: 'Sensor',
          global_search_placeholder:
            'Buscar distribuciones, unidades agrícolas, campos y sensores',
          global_search_empty_hint:
            'Empieza a escribir para buscar por nombre o ID',
          global_search_no_results: 'No se encontraron resultados',
          global_search_more_results:
            'Mostrando los primeros {{shown}} de {{total}} resultados',
          global_search_recent_fields: 'Campos recientes',
          global_search_hint_navigate: 'Navegar',
          global_search_hint_select: 'Seleccionar',
          'my fields': 'Mis campos',
          sensor_batch: 'Lote de sensor',
          transmission_interval: 'Intervalo de transmisión',
          start: 'Comienzo',
          end: 'Fin',
          discharge: 'Descarga',
          'recent wfr samples': 'Valores recientes del medidor de agua',
          'choose layer': 'Elegir capa',
          planning_days: 'Días',
          planning_weeks: 'Semanas',
          planning_publish: 'Publicar',
          recent_errors_values: 'Valores de error recientes',
          sim_last_event: 'Último evento del SIM',
          stress_level_no_stress: 'Sin estrés',
          next_actions: 'Próximas acciones',
          tomorrow: 'Mañana',
          later: 'Más tarde',
          coming_soon: 'En breve',
          no_planner_events: 'No hay acciones futuras en este momento',
          history_graph: 'Gráfico histórico',
          planning_planned: 'PLANEADO',
          planning_used: 'EJECUTADO',
          event: 'Evento',
          ' hcl': 'HCl',
          hpo: 'HPO',
          note: 'Observación',
          planning_note_placeholder: 'Escribe aquí tu mensaje',
          sensors: 'sensores',
          valves: 'válvulas',
          type: 'tipo',
          'coming up': 'Subiendo',
          water_potential_graph: 'Grafico de potencial de agua',
          locate_coordinates: 'Encontrar coordenadas',
          ignore_sensor_during_calculations:
            'Ignorar el sensor en los cálculos',
          ignore_sensor_during_calculations_and_hide:
            'Ocultar e ignorar el sensor en los cálculos',
          consider_as_flow_meter: 'Considerar como medidor de flujo',
          edit: 'Editar',
          alerts: 'Alertas',
          stop_data_collection: 'Detener la recogida de datos',
          accumulated_water_input: 'Entrada de agua acumulada',
          soil_temperature: 'Temperatura del Suelo',
          soil_temperature_graph_title: 'Temperatura del Suelo',
          precipitation: 'lluvia',
          petiole: 'Pecíolo',
          water_potential: 'Potencial de agua',
          irrigation_activity: 'Actividad de riego',
          root_zone_water_potential: 'Potencial hídrico de la zona radicular',
          minimum: 'Mín',
          maximum: 'Máx',
          max_bigger_than_min:
            'El valor máximo debe ser mayor que el valor mínimo',
          min_smaller_than_max:
            'El valor mínimo debe ser menor que el valor máximo',
          moderator: 'Moderador',
          designed_pressure: 'Presión estimada',
          field_size: 'Tamaño del campo',
          duplicate_field: 'duplicar el campo',
          duplicate: 'duplicar',
          offset: 'Offset',
          'Nitrogen graph': 'Gráfico de Nitrógeno',
          select_all: 'Seleccionar todo',
          select_water_input: 'seleccionar entrada de agua',
          'Planned irrigation': 'Riego planificado',
          days_from_sowing: 'Días después de la siembra',
          Field_details_days_in_season: 'Días en temporada',
          day_sunday: 'Domingo',
          day_monday: 'Lunes',
          day_tuesday: 'Martes',
          day_wednesday: 'Miércoles',
          day_thursday: 'Jueves',
          day_friday: 'Viernes',
          day_saturday: 'Sábado',
          week: 'semana',
          season: 'estación',
          today: 'hoy',
          show_archived: 'Mostrar archivados',
          events_list: 'Lista de eventos',
          notes: 'Notas',
          week_total: 'Total semanal',
          season_total: 'Total temporada',
          no_reported: 'Ningún evento agregado',
          report_event: 'Reportar evento',
          save: 'ahorrar',
          rain: 'lluvia',
          starting_time: 'hora de inicio',
          fertilization: 'fertilización',
          reported: 'Agregados',
          plant_height: 'Altura de planta',
          fert_tank_height: 'Nivel del tanque de fertilización',
          Fert_tank_volume: 'Volumen del tanque de fertilización',
          allow_notifications: 'Permitir notificaciones',
          notifications_channels: 'En qué canales serás notificado',
          event_type: 'Tipo de evento',
          push: 'Activar',
          recommendations: 'Recomendaciones',
          field_notifications:
            'Quais notificações você receberá para cada campo',
          none: 'Ninguno',
          notifications_phase:
            'Controlar los tipos de notificación y canales a través de los cuales seré notificado',
          alerts_tooltip:
            'Las alertas indican eventos adversos que requieren acción inmediata para proteger los cultivos',
          recent_connectivity_values: 'Valores de conectividad recientes',
          alerts_message_continuous_irrigation_notification_center_title:
            'Alerta de riego continuo - fieldX',
          alerts_message_continuous_irrigation_notification_center_body:
            'Hemos detectado riego continuo durante más de 2 días para el campo. Para proteger los cultivos, le recomendamos comprobar si el campo está siendo regado en exceso.',
          low_pressure_event_hint: 'Presión baja detectada en este riego',
          high_pressure_event_hint: 'Presión alta detectada en este riego',
          low_pressure_detected_value: 'Presión baja detectada: {{value}}',
          high_pressure_detected_value: 'Presión alta detectada: {{value}}',
          alerts_message_low_pressure_notification_center_title:
            'Presión baja detectada en fieldX',
          alerts_message_low_pressure_notification_center_body:
            'La presión medida en fieldX cayó por debajo del mínimo definido para este sensor, lo que puede reducir el agua aplicada y afectar su distribución en el campo. Recomendamos revisar los filtros, las válvulas y las tuberías.',
          alerts_message_high_pressure_notification_center_title:
            'Presión alta detectada en fieldX',
          alerts_message_high_pressure_notification_center_body:
            'La presión medida en fieldX superó el máximo definido para este sensor, lo que puede forzar el sistema de riego y afectar la distribución del agua. Recomendamos revisar la regulación de presión y las válvulas aguas abajo.',
          alerts_message_sensor_extreme_dry_conditions_notification_center_title:
            'Condiciones de sequía extrema detectadas en el campo - Datos recibidos del sensorX',
          alerts_message_long_dry_period_notification_center_title:
            'Largo período sin riego -  Recomendados el riego del fieldX',
          alerts_message_sensor_extreme_dry_conditions_notification_center_body:
            'Los datos recibidos por el sensorX indican una condición extremadamente seca en el campo. Para garantizar datos precisos y protección de cultivos, recomendamos inspeccionar el plan de riego, y el sistema de riego alrededor del sensor.',
          alerts_message_long_dry_period_notification_center_body:
            'El fieldX no ha recibido agua durante 10 días, lo que puede provocar estrés hídrico. Para proteger los cultivos, recomendamos regar el campo siguiendo tu plan de riego N-Drip.',
          alerts_message_drying_trend_notification_center_title:
            'Tendencia de secado detectada en su campo',
          alerts_message_drying_trend_notification_center_body:
            'Observamos una tendencia decreciente del potencial hídrico en el fieldX, por debajo del nivel recomendado. Para optimizar los cultivos, revisa y ajusta tu plan de riego actual según las recomendaciones de N-Drip.',
          alerts_message_wetting_trend_notification_center_title:
            'Tendencia de humedecimiento detectada en su campo',
          alerts_message_wetting_trend_notification_center_body:
            'Observamos una tendencia creciente del potencial hídrico en el fieldX, por encima del nivel recomendado. Para optimizar los cultivos, revisa y ajusta tu plan de riego actual según las recomendaciones de N-Drip.',
          alerts_message_excessive_heat_notification_center_title:
            'Alta temperatura del aire',
          alerts_message_excessive_heat_notification_center_body:
            'Se pronostica alta temperatura del aire para la zona del fieldX, durante los próximos días.\nPara proteger sus cultivos revisa y ajusta tu plan de riego actual según nuestras recomendaciones actualizadas.',
          alerts_message_extreme_cold_notification_center_title:
            'Alerta de ola de frio',
          alerts_message_extreme_cold_notification_center_body:
            'Se pronostica una importante ola de frio para la zona del fieldX durante los próximos días. Para proteger sus cultivos de los daños causados por las heladas, revisa y ajusta tu plan de riego actual según nuestras recomendaciones actualizadas.',
          notifications_welcome_message_title:
            'Bem-vindo ao novo painel de notificações',
          notifications_welcome_message_body:
            'Fique por dentro de eventos importantes atuais e esperados em suas lavouras no desktop e dispositivos móveis',
          alerts_message_dryland_long_dry_period_notification_center_title:
            'Largo período seco detectado',
          alerts_message_dryland_long_dry_period_notification_center_body:
            'El fieldX no ha recibido agua durante 10 días, lo que puede provocar estrés hídrico.',
          alerts_message_dryland_sensor_exterme_dry_notification_center_title:
            'Condiciones de sequía extrema detectadas en el campo - Datos recibidos del sensorX',
          alerts_message_dryland_sensor_exterme_dry_notification_center_body:
            'Los datos recibidos por el sensorX indican una condición extremadamente seca en el campo.',
          alerts_message_dryland_drying_trend_notification_center_title:
            'Tendencia de secado detectada en su campo',
          alerts_message_dryland_drying_trend_notification_center_body:
            'Observamos una tendencia decreciente del potencial hídrico en el fieldX, lo que puede provocar estrés hídrico.',
          alerts_message_dryland_wetting_trend_notification_center_title:
            'Tendencia de humedecimiento detectada en su campo',
          alerts_message_dryland_wetting_trend_notification_center_body:
            'Observamos una tendencia creciente del potencial hídrico en el fieldX, lo que puede provocar estrés hídrico.',
          alerts_message_dryland_excessive_heat_notification_center_title:
            'Alerta de ola de calor',
          alerts_message_dryland_excessive_heat_notification_center_body:
            'Se pronostica una importante ola de calor para la zona del fieldX durante los próximos días.',
          alerts_message_dryland_extreme_cold_notification_center_title:
            'Alerta de ola de frio',
          alerts_message_dryland_extreme_cold_notification_center_body:
            'Se pronostica una importante ola de frio para la zona del fieldX durante los próximos días.',
          alerts_message_dryland_ndvi_notification_center_title:
            'Reducción de la actividad vegetativa',
          alerts_message_dryland_ndvi_notification_center_body:
            'Análisis recientes de imágenes históricas del NDVI reveló una reducción significativa en el crecimiento vegetativo en el fieldX. Para optimizar la salud de su cultivo, revise sus prácticas de riego actuales.',
          no_notifications: 'Actualmente no hay notificaciones',
          load_more: 'Cargar más',
          all_fields: 'Todos los campos',
          current_field: 'Campo actual',
          planner_days_shorts_sun: 'Dom',
          planner_days_shorts_mon: 'Lun',
          planner_days_shorts_tue: 'Mar',
          planner_days_shorts_wed: 'Mie',
          planner_days_shorts_thu: 'Jue',
          planner_days_shorts_fri: 'Vie',
          planner_days_shorts_sat: 'Sab',
          shorts_months_january: 'Ene',
          shorts_months_february: 'Feb',
          shorts_months_march: 'Mar',
          shorts_months_april: 'Abr',
          shorts_months_may: 'Mayo',
          shorts_months_june: 'Jun',
          shorts_months_july: 'Jul',
          shorts_months_august: 'Ago',
          shorts_months_september: 'Sept',
          shorts_months_october: 'Oct',
          shorts_months_november: 'Nov',
          shorts_months_december: 'Dic',
          dont_show_again: 'No mostrar de nuevo',
          notifications_settings: 'Configuración de notificaciones',
          read_more: 'Leer más',
          show_less: 'Mostrar menos',
          distribution_menu_select: 'Seleccionar distribución',
          farming_unit_menu_select: 'Seleccionar Unidade Agrícola',
          field_menu_select: 'Seleccionar campo',
          recent_field: 'Campo reciente',
          discharge_test: 'Prueba de descarga',
          create_planner_item: 'Agregar nuevo evento',
          update_planner_item: 'Actualizar evento',
          planner_season_start: 'Inicio de temporada',
          planner_season_end: 'Fin de temporada',
          planner_growth_phase_initial: 'Inicial',
          planner_growth_phase_development: 'Desarrollo',
          planner_growth_phase_middle: 'Medio',
          planner_growth_phase_late: 'Final',
          planner_add_event_button: 'Agregar evento',
          planner_water_treatment: 'Tratamiento de agua',
          planner_add_button: 'Agregar',
          planner_start_time: 'Hora de inicio',
          dashboard_move_to_archive: 'Mover al archivo',
          dashboard_unarchive: 'Desarchivado',
          Insights_title_county: 'Condado',
          Insights_group_by: 'Agrupado por',
          edit_field_measured_irrigation_rate: 'Tasa de riego medida',
          edit_field_tank_type: 'Tipo del tanque de agua',
          edit_field_recommendation_display: 'Mostrar datos de riego en',
          recommendation_display_duration: 'Duración',
          recommendation_display_amount: 'Cantidad',
          edit_field_recommendation_display_description:
            'Duración es el valor predeterminado para sistemas N-Drip, Seepage, Flood y Furrow; Cantidad para el resto. Cambiar el tipo de riego restablece esta opción al valor predeterminado del sistema.',
          edit_field_representative_input_checkbox:
            'Utilice los valores de tasa de riego medidos quando estén disponibles. Esto afectará la planificación del riego.',
          edit_field_custom_irrigation_rate: 'Personalizar tasa de riego',
          wtr_reported_successfully: 'Tratamiento de agua reportado con éxito',
          kc_phases_stress_checkbox: 'Aplicar estrés',
          kc_phases_stress_tooltip:
            'Iniciar un periodo planificado de estrés hídrico según el siguiente porcentaje de reducción de ETc',
          edit_field_irrigation_timeframe_source_soil:
            'limitación por tipo de suelo',
          edit_field_irrigation_timeframe_source_irrigation_rate:
            'Tasa de riego',
          edit_field_irrigation_timeframe_source_user:
            'definido por el usuario',
          edit_field_irrigation_timeframe_tooltip: 'Limitación original:',
          source: 'Origen',
          discharge_result_exceeding_hint:
            'El resultado de la prueba se desvia de la curva de tendencia de descarga',
          Timeframe_no_end_date: 'Hasta nuevo aviso',
          Farming_unit_entity_basic_info: 'Información básica',
          'Farming_unit_entity_add_new ': 'Agregar nuevo',
          add_new_button: 'Agregar nuevo',
          WT_protocol_edit_field_water_properties_section_title:
            'Propiedades del agua',
          WT_protocol_edit_field_water_source: 'Fuente de agua',
          WT_protocol_edit_field_water_conveyance: 'Transporte',
          WT_protocol_edit_field_water_analysis_section_title:
            'Análisis de agua',
          WT_protocol_edit_field_water_analysis_section_subtitle:
            'Ver rangos de recomendación en cada celda',
          WT_protocol_edit_field_water_analysis_table_materials: 'Materiales',
          WT_protocol_edit_field_water_analysis_table_score: 'Puntuación',
          WT_protocol_edit_field_water_analysis_table_low: 'Bajo',
          WT_protocol_edit_field_water_analysis_table_medium: 'Promedio',
          WT_protocol_edit_field_water_analysis_table_high: 'Alto',
          WT_protocol_edit_field_water_analysis_table_organic: 'Orgánico',
          WT_protocol_edit_field_water_analysis_table_calc: 'Cálculo',
          WT_protocol_edit_field_water_analysis_table_fe: 'Hierro',
          WT_protocol_edit_field_material_concentrations:
            'Concentración de materiales',
          WT_protocol_edit_field_acid_titration: 'Titulación ácida',
          Farming_unit_entity_tooltip:
            'Los elementos deshabilitados se pueden editar a través de la unidad agrícola',
          WT_timing_recommendation_after_irrigation_starts:
            'Después de 30min de riego',
          WT_timing_recommendation_last_hour: 'Última hora de riego',
          fertilizer_meter_id: ' Identificación del medidor de fertilizantes',
          add_fertilizer: 'Agregar fertilizante',
          Farming_unit_entity_all: 'Todas',
          basic_info: 'Informações básicas',
          Edit_field_planner_dynamic_update_title:
            'Permitir actualizaciones dinámicas',
          Edit_field_planner_dynamic_update_description:
            'Las recomendaciones se verán afectadas por los cambios de riego en cualquier momento.',
          KC_phases_title: 'Fase de crecimiento',
          KC_phases_title_pre_season: 'Pretemporada',
          KC_phases_title_in_between_seasons: 'Entre temporadas',
          KC_phases_season_end: 'Fin de temporada',
          KC_phases_phase_tooltip_start: 'Comienzo',
          KC_phases_phase_tooltip_end: 'Fin',
          KC_phases_button_save: 'Ahorrar',
          KC_phases_button_reset: 'Reiniciar',
          KC_phases_stress_inidication: 'Riego deficitatio controlado',
          KC_phases_button_edit: 'Editar',
          KC_phases_fast_flow: 'Configurar fase actual',
          KC_phases_now_indication: 'Ahora',
          KC_phases_estimated_short: 'Est.',
          KC_phases_estimated_season_end: 'Probable fin de la temporada',
          KC_phases_edit_mode_default_title:
            'Haga clic en la fase para ajustar su duración',
          kc_phases_error_message:
            'El valor ingresado está en conflito con otros valores',
          edit_field_timeframe_constraint_first_day: 'Primer día de la semana',
          edit_field_timeframe_constraint_season_target:
            'Objetivo de riego estacional',
          edit_field_timeframe_constraint_weekly_mode:
            'Semanal (máximo x veces por semana)',
          edit_field_timeframe_constraint_interval_mode:
            'Intervalo (al menos cada x días)',
          edit_field_planner_type_no_planner: 'Sin programa',
          edit_field_planner_type_by_day: 'Recomendación diaria',
          edit_field_planner_no_irrigation: 'Sin riego',
          edit_field_planner_changes_message_first_day_body:
            'Las recomendaciones se verán afectadas por el cambio del primer día de la semana',
          edit_field_planner_changes_message_mode_body:
            'Las recomendaciones se verán afectadas por el cambio del modo de riego',
          select_graphs: 'Seleccionar gráficos',
          accumulated_graph_baseline_recommendation_more_info_description:
            'ETc basada en el modelo de cultivo (ETo x Kc), ajustada a su sistema de riego.',
          accumulated_graph_adaptive_recommendation_more_info_description:
            'ETc basada en el Kc optimizado, ajustada a su sistema de riego.',
          accumulated_graph_title_baseline_recommendation:
            'Recomendación de referencia',
          accumulated_graph_title_adaptive_recommendation:
            'Recomendación adaptada',
          field_list_title_: 'Lista de campos',
          soil_temperature_values:
            'Temp del suelo diária media, max, y última hora',
          report_issue: 'Reportar problema',
          report_issue_for: 'Reportar problema a',
          report_issue_title:
            'Seleccione el problema relevante de la lista. Se enviará automáticamente información adicional sobre el campo.',
          report_issue_placeholder:
            '¿Qué más puede ayudar a aclarar el problema?',
          report_issue_error:
            'Se produjo un error al enviar el informe. Inténtelo de nuevo más tarde',
          report_issue_success_message: 'El informe se creó correctamente',
          report_issue_view_on_monday: 'Ver en Monday',
          report_issue_sensor_issues: 'Problemas del sensor',
          report_issue_field_issues: 'Problemas del campo',
          delete_my_data: 'Eliminar Mis Datos',
          delete_data_warning_grace:
            'Esta acción programará la eliminación permanente de todos sus datos del sistema. Tendrá {{days}} días para cancelar esta solicitud antes de que los datos se eliminen permanentemente.',
          delete_data_confirm:
            '¿Está seguro de que desea eliminar todos sus datos?',
          delete_data_success_grace:
            'Su solicitud de eliminación de datos ha sido enviada. Sus datos se eliminarán permanentemente en {{days}} días.',
          delete_data_confirmation_email:
            'Se ha enviado un correo electrónico de confirmación a su dirección de correo. Puede cancelar esta solicitud dentro del período de gracia contactando al soporte.',
          delete_data_button: 'Eliminar Todos Mis Datos',
          delete_data_confirm_button: 'Sí, Eliminar Mis Datos',
          delete_data_error:
            'Se produjo un error al eliminar sus datos. Inténtelo de nuevo más tarde.',
          delete_data_enter_password: 'Ingrese su contraseña para confirmar',
          delete_data_password_required:
            'Se requiere contraseña para continuar',
          delete_data_reason_label:
            '¿Por qué está eliminando sus datos? (opcional)',
          delete_data_reason_select: 'Seleccione un motivo...',
          delete_data_reason_no_longer_need: 'Ya no necesito el servicio',
          delete_data_reason_privacy_concerns: 'Preocupaciones de privacidad',
          delete_data_reason_switching_service: 'Cambio a otro servicio',
          delete_data_reason_too_complex: 'El servicio es demasiado complejo',
          delete_data_reason_other: 'Otro',
          high_pressure: 'Alta presión',
          height: 'Altura',
          metric_india: 'Metrico (India)',
          metric_israel: 'Metrico (Israel)',
          metric_australia: 'Metrico (Australia)',
          metric: 'Metrico',
          imperial: 'Imperial',
          unit_system: 'Sistema de unidades',
          recommendations_unit: 'Unidad de recomendaciones',
          none_default: 'Ninguno - Predeterminado',
          no_recommendation: 'Sin Recomendacion',
          support_planner: 'Planificador de Soporte',
          activity_dates: 'Fechas de actividad',
          fertilization_reported_successfully:
            'Fertilizacion Reportada Exitosamente',
          rain_reported_successfully: 'Lluvia Reportada Exitosamente',
          sample_interval: 'Intervalo de Muestreo',
          planning: 'Planificacion',
          crop_water_availability: 'Disponibilidad de\nAgua del Cultivo',
          water_availability_high: 'Alta',
          water_availability_medium: 'Media',
          water_availability_low: 'Baja',
          water_availability_no_data: 'Sin Datos',
          ndvi_layer: 'Capa NDVI',
          farm_map: 'Mapa de la granja',
          field_details: 'Detalles del campo',
          select_a_field_to_view_details:
            'Seleccione un campo para ver el gráfico de potencial hídrico',
          select_a_field_to_view_its_details:
            'Seleccione un campo para ver sus detalles',
          date_chip_1d: '1D',
          date_chip_1w: '1S',
          date_chip_2w: '2S',
          date_chip_1m: '1M',
          date_chip_6m: '6M',
          date_chip_1y: '1A',
          graphs: 'Gráficos',
          map: 'Mapa',
          previous: 'Anterior',
          next: 'Siguiente',
          field_name: 'Nombre del Campo',
          sort: 'Ordenar',
          advanced: 'Avanzado',
          advanced_mode: 'Modo Avanzado',
          unknown_field: 'Parcela Desconocida',
          not_available: 'No disponible',
          irrigating: 'Irrigando',
          no_data: 'Sin datos',
          plan: 'Plan',
          since_date: 'Desde {{date}}',
          flow_meter_source: 'Caudalímetro',
          manual_input_source: 'Entrada Manual',
          connect_sensor_source: 'Sensor Conectado',
          no_fields_available: 'No hay parcelas disponibles',
          fields: 'Parcelas',
          recommendation: 'Recomendación',
          stress_level: 'Nivel de Estrés',
          root_zone_wp: 'PH Zona Radicular',
          map_satellite: 'Satélite',
          map_topography: 'Topografía',
          map_streets: 'Calles',
          ndvi_timeline: 'Línea de tiempo NDVI',
          events: 'eventos',
          hcl: 'HCl',
          notify: 'notificar',
          irrigation_system: 'Sistema de Riego',
          irrigation_type: 'Tipo de Riego',
          irrigation_rate: 'Tasa de Riego',
          irrigation_time_frames: 'Horarios de Riego',
          define_time_frames: 'Definir horarios disponibles para riego',
          start_day: 'Dia de inicio',
          start_hour: 'Hora de inicio',
          end_hour: 'Hora de fin',
          time_frame_conflict:
            'El horario seleccionado entra en conflicto con un horario existente',
          select_different_hour: 'Por favor seleccione una hora diferente',
          select_different_day: 'Por favor seleccione un dia diferente',
          no_time_frames: 'No hay restricciones de horarios de riego',
          for_this_field: 'para este campo en este momento',
          updated: 'Actualizado',
          last_synced: 'Última sincronización:',
          not_yet_set: 'Aun no configurado',
          missing_values: 'Faltan valores',
          start_date: 'Fecha de inicio',
          end_date: 'Fecha de fin',
          fertigation_concentrations: 'Concentraciones de fertirrigacion',
          no_fertigation_concentrations_message:
            'No hay concentraciones de fertirrigacion',
          sensor_type: 'Tipo de sensor',
          sensor_sub_type: 'Subtipo de sensor',
          alphabetic: 'Alfabetico',
          sort_by: 'Ordenar por',
          sort_alphabetic: 'Alfabetico',
          sort_crop_availability: 'Disponibilidad de agua del cultivo',
          sort_last_irrigation_new_old: 'Ultimo riego (Nuevo → Antiguo)',
          sort_last_irrigation_old_new: 'Ultimo riego (Antiguo → Nuevo)',
          sort_last_irrigation_duration_short_long:
            'Ultimo riego (Mas corta → Mas larga)',
          sort_last_irrigation_duration_long_short:
            'Ultimo riego (Mas larga → Mas corta)',
          sort_weekly_performance_high_low: 'Rendimiento semanal (Alto → Bajo)',
          sort_weekly_performance_low_high: 'Rendimiento semanal (Bajo → Alto)',
          Almond: 'Almendro',
          Apple: 'Manzano',
          Arugula: 'Rucula',
          Blueberry: 'Arandano',
          Broccoli: 'Brocoli',
          Fig: 'Higuera',
          Garlic: 'Ajo',
          Guayule: 'Guayule',
          Jojoba: 'Jojoba',
          Kiwi: 'Kiwi',
          Loquat: 'Nispero',
          Mandarin: 'Mandarina',
          Moringa: 'Moringa',
          Nectarine: 'Nectarina',
          Orange: 'Naranjo',
          Peach: 'Durazno',
          Peony: 'Peonia',
          Raspberry: 'Frambuesa',
          Planner: 'Planificador',
          Irrigated: 'Regado',
          search_by_field: 'Buscar Por Campo',
          free_search: 'Busqueda Libre',
          transmitters: 'Transmisores',
          transmitter_name: 'Nombre del Transmisor',
          details: 'detalles',
          next_day: 'Dia siguiente',
          crop_management: 'Gestion de Cultivos',
          add_new_crop: 'Agregar Nuevo Cultivo',
          edit_parameters: 'Editar Parametros',
          select_or_enter_crop_type: 'Seleccionar o ingresar tipo de cultivo',
          select_or_enter_variety: 'Seleccionar o ingresar variedad',
          enter_sub_variety: 'Ingresar sub variedad (opcional)',
          select_or_enter_feature: 'Seleccionar o ingresar caracteristica',
          select_crop: 'Seleccionar cultivo...',
          phenological_phases: 'Fases Fenologicas',
          gdd_parameters: 'Parametros GDD',
          yield_parameters: 'Parametros de Rendimiento',
          fields_using_crop: 'Campos Usando Este Cultivo',
          permission_hint:
            'Solo se muestran los campos que tiene permiso para ver',
          no_fields_found:
            'No se encontraron campos usando esta configuracion de cultivo',
          select_crop_hint:
            'Seleccione un tipo de cultivo para ver y editar parametros',
          loading_crop_data: 'Cargando datos de cultivo...',
          add_phase: 'Agregar Fase',
          duration_days: 'Duracion (Dias)',
          duration_gdd: 'Duracion (GDD)',
          is_development: 'Es Desarrollo',
          stress_active: 'Estres Activo',
          stress_factor: 'Factor de Estres',
          inherited: 'Heredado',
          crop_updated_successfully: 'Cultivo actualizado exitosamente',
          crop_update_failed: 'Error al actualizar el cultivo',
          crop_added_successfully: 'Cultivo agregado exitosamente',
          crop_add_failed: 'Error al agregar el cultivo',
          crop_key_already_exists: 'Esta clave de cultivo ya existe',
          number_of_fields: 'Numero de campos',
          total_area: 'Area total',
          total_water_usage: 'Uso total de agua',
          total_fertilizers_usage: 'Uso total de fertilizantes',
          total_nitrogen_leached: 'Nitrogeno total lixiviado',
          crop_types: 'Tipos de cultivo',
          measurement: 'medicion',
          containing: 'que contiene',
          no_cluster: 'Sin Cluster',
          selected_field_only: 'Solo el campo seleccionado',
          farming_type: 'Tipo de cultivo',
          fert_tank: 'Tanque de fertilizante',
          calibration_data: 'Datos de calibracion',
          recommendations_tooltip:
            'Las recomendaciones son informacion que ayuda a optimizar los rendimientos y mejorar la toma de decisiones',
          login_enter_your_email_forgot_password:
            'Ingrese su correo electronico y le enviaremos un codigo para restablecer su contrasena:',
          alerts_message_low_tank_fert_notification_center_title:
            'Nivel bajo de fertilizante detectado en fieldX',
          alerts_message_low_tank_fert_notification_center_body:
            'Hemos detectado que el nivel de fertilizante en el tanque de fieldX ha alcanzado el umbral minimo del 10% de la altura operativa del tanque. Por favor, organice el rellenado del tanque para asegurar la fertilizacion continua de los cultivos.',
          country: 'Pais',
          monday_id: 'Monday ID',
          delete_item_title: 'El elemento sera eliminado',
          delete_item_text:
            'Esta accion no se puede revertir y los datos se perderan',
          average: 'Promedio',
          seconds: 'seg',
          event_delete_successfully: 'El evento fue eliminado exitosamente',
          reported_successfully: 'La prueba ha sido reportada exitosamente',
          report_unsuccessfully:
            'El evento no puede ser reportado en este momento. Por favor intente de nuevo mas tarde',
          event_delete_unsuccessfully:
            'El evento no puede ser eliminado en este momento, por favor intente de nuevo mas tarde',
          wtr_checkbox: 'Incluir tratamiento de agua',
          WT_protocol_edit_field_HPO_concentrations: 'Concentraciones de HPO',
          Fert_sensor_fertlization_type: 'Tipo de fertilizante',
          KC_phases_season_ended: 'Temporada finalizada',
          installation_depth: 'Profundidad',
          edit_field_timeframe_no_frequnecy_constraint:
            'Si no se definen horarios, el planificador se ejecutara todos los dias',
          add_time_frames: 'Agregue restricciones de horario para verlas aqui',
          assumption: 'Supuesto',
          issue: 'Problema',
          extract_sensor: 'Extraer Sensor',
          select_assumption: 'Seleccionar supuesto',
          select_sensor: 'Seleccionar sensor',
          comment: 'Comentario',
          reporting: 'Reportando...',
          air_burst: 'Rafaga de Aire',
          bad_values: 'Valores Incorrectos',
          no_transmission: 'Sin Transmision',
          low_pressure_detected: 'Presion baja detectada',
          high_pressure_detected: 'Presion alta detectada',
          long_dry_period: 'Periodo seco prolongado',
          drying_trend: 'Tendencia de secado',
          wetting_trend: 'Tendencia de humectacion',
          sensor_not_responding_to_irrigation: 'El sensor no responde al riego',
          missed_irrigation: 'Riego omitido',
          continuous_irrigation: 'Riego continuo',
          select_placeholder: 'Seleccionar...',
        },
      },
      hin: {
        translations: {},
      },

      ger: {
        translations: {},
      },
      fre: {
        translations: {},
      },
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
    },

    react: {
      useSuspense: false,
    },
  });
